/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type { paths } from "../schema";
import type { DeepReadonly, InvalidateQueryFilters, MutationFiltersByMutationKey, MutationFiltersByParameters, MutationVariables, OperationError, OperationInfiniteData, PartialParameters, QueryFiltersByParameters, QueryFiltersByQueryKey, QueryFnOptionsByParameters, QueryFnOptionsByQueryKey, RequestFnResponse, ServiceOperationEnsureInfiniteQueryDataOptions, ServiceOperationEnsureQueryDataOptions, ServiceOperationFetchInfiniteQueryOptions, ServiceOperationFetchQueryOptions, ServiceOperationInfiniteQueryKey, ServiceOperationMutationFnOptions, ServiceOperationMutationKey, ServiceOperationQueryKey, ServiceOperationUseMutationOptions, UseQueryOptionsForUseQueries, UseQueryOptionsForUseSuspenseQuery, WithOptional, QraftServiceOperationsToken } from "@openapi-qraft/tanstack-query-react-types";
import type { CancelOptions, DefinedInitialDataInfiniteOptions, DefinedInitialDataOptions, DefinedUseInfiniteQueryResult, DefinedUseQueryResult, InfiniteQueryPageParamsOptions, InvalidateOptions, Mutation, MutationCache, MutationState, NoInfer, QueryState, RefetchOptions, ResetOptions, SetDataOptions, UndefinedInitialDataInfiniteOptions, UndefinedInitialDataOptions, Updater, UseInfiniteQueryResult, UseMutationResult, UseQueryResult, UseSuspenseInfiniteQueryOptions, UseSuspenseInfiniteQueryResult, UseSuspenseQueryOptions, UseSuspenseQueryResult } from "@tanstack/react-query";
export interface LiteappApiService {
    /**
     * @summary Admin Forced
     * @description Admin/dev impersonation login: return a target user's auth token + profile.
     *
     * The target is restricted to the student/study-helper groups. The token is
     * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
     * gate guarded non-local envs only and the app never sends a passcode, so this
     * is treated as the dev/local-bypass path.
     */
    adminForcedLiteappApiAuthAdminForcedPost: {
        /**
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters, TMeta, TSignal>, client?: (schema: AdminForcedLiteappApiAuthAdminForcedPostSchema, options: ServiceOperationMutationFnOptions<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostError>>): Promise<RequestFnResponse<AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostError>>;
        /**
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         */
        getMutationKey(parameters: DeepReadonly<AdminForcedLiteappApiAuthAdminForcedPostParameters> | void): ServiceOperationMutationKey<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends AdminForcedLiteappApiAuthAdminForcedPostBody, TContext = unknown>(parameters: DeepReadonly<AdminForcedLiteappApiAuthAdminForcedPostParameters>, options?: ServiceOperationUseMutationOptions<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, TVariables, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>): UseMutationResult<AdminForcedLiteappApiAuthAdminForcedPostData, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, TVariables, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>): UseMutationResult<AdminForcedLiteappApiAuthAdminForcedPostData, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const adminForcedLiteappApiAuthAdminForcedPostTotal = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const adminForcedLiteappApiAuthAdminForcedPostTotal = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const adminForcedLiteappApiAuthAdminForcedPostPendingMutationVariables = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const adminForcedLiteappApiAuthAdminForcedPostMutationData = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-device-token": xWbsDeviceToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<AdminForcedLiteappApiAuthAdminForcedPostData, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, MutationVariables<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>;
            select?: (mutation: Mutation<AdminForcedLiteappApiAuthAdminForcedPostData, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, MutationVariables<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Admin Forced
         * @description Admin/dev impersonation login: return a target user's auth token + profile.
         *
         * The target is restricted to the student/study-helper groups. The token is
         * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
         * gate guarded non-local envs only and the app never sends a passcode, so this
         * is treated as the dev/local-bypass path.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.adminForcedLiteappApiAuthAdminForcedPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>): Mutation<AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostError, MutationVariables<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext> | MutationFiltersByMutationKey<AdminForcedLiteappApiAuthAdminForcedPostSchema, AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostParameters, OperationError<AdminForcedLiteappApiAuthAdminForcedPostError>, TContext>): Array<Mutation<AdminForcedLiteappApiAuthAdminForcedPostData, AdminForcedLiteappApiAuthAdminForcedPostError, MutationVariables<AdminForcedLiteappApiAuthAdminForcedPostBody, AdminForcedLiteappApiAuthAdminForcedPostParameters>, TContext>>;
        };
        schema: AdminForcedLiteappApiAuthAdminForcedPostSchema;
        types: {
            parameters: AdminForcedLiteappApiAuthAdminForcedPostParameters;
            data: AdminForcedLiteappApiAuthAdminForcedPostData;
            error: AdminForcedLiteappApiAuthAdminForcedPostError;
            body: AdminForcedLiteappApiAuthAdminForcedPostBody;
        };
    };
    /**
     * @summary Forget Password
     * @description Request a password reset (pre-auth, device-verified only).
     *
     * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
     * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
     * so this endpoint builds the envelope directly via ``JSONResponse``.
     */
    forgetPasswordLiteappApiAuthForgetPasswordPost: {
        /**
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, TMeta, TSignal>, client?: (schema: ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, options: ServiceOperationMutationFnOptions<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostError>>): Promise<RequestFnResponse<ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostError>>;
        /**
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         */
        getMutationKey(parameters: DeepReadonly<ForgetPasswordLiteappApiAuthForgetPasswordPostParameters> | void): ServiceOperationMutationKey<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends ForgetPasswordLiteappApiAuthForgetPasswordPostBody, TContext = unknown>(parameters: DeepReadonly<ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>, options?: ServiceOperationUseMutationOptions<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, TVariables, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>): UseMutationResult<ForgetPasswordLiteappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, TVariables, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>): UseMutationResult<ForgetPasswordLiteappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const forgetPasswordLiteappApiAuthForgetPasswordPostTotal = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const forgetPasswordLiteappApiAuthForgetPasswordPostTotal = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const forgetPasswordLiteappApiAuthForgetPasswordPostPendingMutationVariables = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const forgetPasswordLiteappApiAuthForgetPasswordPostMutationData = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<ForgetPasswordLiteappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, MutationVariables<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>;
            select?: (mutation: Mutation<ForgetPasswordLiteappApiAuthForgetPasswordPostData, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, MutationVariables<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Forget Password
         * @description Request a password reset (pre-auth, device-verified only).
         *
         * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
         * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
         * so this endpoint builds the envelope directly via ``JSONResponse``.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.forgetPasswordLiteappApiAuthForgetPasswordPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>): Mutation<ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostError, MutationVariables<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext> | MutationFiltersByMutationKey<ForgetPasswordLiteappApiAuthForgetPasswordPostSchema, ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters, OperationError<ForgetPasswordLiteappApiAuthForgetPasswordPostError>, TContext>): Array<Mutation<ForgetPasswordLiteappApiAuthForgetPasswordPostData, ForgetPasswordLiteappApiAuthForgetPasswordPostError, MutationVariables<ForgetPasswordLiteappApiAuthForgetPasswordPostBody, ForgetPasswordLiteappApiAuthForgetPasswordPostParameters>, TContext>>;
        };
        schema: ForgetPasswordLiteappApiAuthForgetPasswordPostSchema;
        types: {
            parameters: ForgetPasswordLiteappApiAuthForgetPasswordPostParameters;
            data: ForgetPasswordLiteappApiAuthForgetPasswordPostData;
            error: ForgetPasswordLiteappApiAuthForgetPasswordPostError;
            body: ForgetPasswordLiteappApiAuthForgetPasswordPostBody;
        };
    };
    /**
     * @summary Login
     * @description Email/password login.
     *
     * Order: validate user_login/password -> verify password (wrong password is
     * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
     * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
     * device token.
     *
     * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
     * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
     * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
     */
    loginLiteappApiAuthLoginPost: {
        /**
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters, TMeta, TSignal>, client?: (schema: LoginLiteappApiAuthLoginPostSchema, options: ServiceOperationMutationFnOptions<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostError>>): Promise<RequestFnResponse<LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostError>>;
        /**
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         */
        getMutationKey(parameters: DeepReadonly<LoginLiteappApiAuthLoginPostParameters> | void): ServiceOperationMutationKey<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LoginLiteappApiAuthLoginPostBody, TContext = unknown>(parameters: DeepReadonly<LoginLiteappApiAuthLoginPostParameters>, options?: ServiceOperationUseMutationOptions<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, TVariables, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>): UseMutationResult<LoginLiteappApiAuthLoginPostData, OperationError<LoginLiteappApiAuthLoginPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, TVariables, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>): UseMutationResult<LoginLiteappApiAuthLoginPostData, OperationError<LoginLiteappApiAuthLoginPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const loginLiteappApiAuthLoginPostTotal = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const loginLiteappApiAuthLoginPostTotal = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const loginLiteappApiAuthLoginPostPendingMutationVariables = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const loginLiteappApiAuthLoginPostMutationData = qraft.liteappApiService.loginLiteappApiAuthLoginPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LoginLiteappApiAuthLoginPostData, OperationError<LoginLiteappApiAuthLoginPostError>, MutationVariables<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>;
            select?: (mutation: Mutation<LoginLiteappApiAuthLoginPostData, OperationError<LoginLiteappApiAuthLoginPostError>, MutationVariables<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Login
         * @description Email/password login.
         *
         * Order: validate user_login/password -> verify password (wrong password is
         * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
         * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
         * device token.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
         * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
         * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.loginLiteappApiAuthLoginPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.loginLiteappApiAuthLoginPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>): Mutation<LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostError, MutationVariables<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext> | MutationFiltersByMutationKey<LoginLiteappApiAuthLoginPostSchema, LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostParameters, OperationError<LoginLiteappApiAuthLoginPostError>, TContext>): Array<Mutation<LoginLiteappApiAuthLoginPostData, LoginLiteappApiAuthLoginPostError, MutationVariables<LoginLiteappApiAuthLoginPostBody, LoginLiteappApiAuthLoginPostParameters>, TContext>>;
        };
        schema: LoginLiteappApiAuthLoginPostSchema;
        types: {
            parameters: LoginLiteappApiAuthLoginPostParameters;
            data: LoginLiteappApiAuthLoginPostData;
            error: LoginLiteappApiAuthLoginPostError;
            body: LoginLiteappApiAuthLoginPostBody;
        };
    };
    /**
     * @summary Register User
     * @description Register a new student.
     *
     * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
     * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
     * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
     * builds the envelope directly via ``JSONResponse`` rather than the shared
     * ``{data: ...}`` handler.
     */
    registerUserLiteappApiAuthRegisterPost: {
        /**
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters, TMeta, TSignal>, client?: (schema: RegisterUserLiteappApiAuthRegisterPostSchema, options: ServiceOperationMutationFnOptions<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostError>>): Promise<RequestFnResponse<RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostError>>;
        /**
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         */
        getMutationKey(parameters: DeepReadonly<RegisterUserLiteappApiAuthRegisterPostParameters> | void): ServiceOperationMutationKey<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends RegisterUserLiteappApiAuthRegisterPostBody, TContext = unknown>(parameters: DeepReadonly<RegisterUserLiteappApiAuthRegisterPostParameters>, options?: ServiceOperationUseMutationOptions<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, TVariables, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>): UseMutationResult<RegisterUserLiteappApiAuthRegisterPostData, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, TVariables, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>): UseMutationResult<RegisterUserLiteappApiAuthRegisterPostData, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const registerUserLiteappApiAuthRegisterPostTotal = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const registerUserLiteappApiAuthRegisterPostTotal = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const registerUserLiteappApiAuthRegisterPostPendingMutationVariables = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const registerUserLiteappApiAuthRegisterPostMutationData = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RegisterUserLiteappApiAuthRegisterPostData, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, MutationVariables<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>;
            select?: (mutation: Mutation<RegisterUserLiteappApiAuthRegisterPostData, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, MutationVariables<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /**
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Register User
         * @description Register a new student.
         *
         * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
         * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
         * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
         * builds the envelope directly via ``JSONResponse`` rather than the shared
         * ``{data: ...}`` handler.
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.registerUserLiteappApiAuthRegisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>): Mutation<RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostError, MutationVariables<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterUserLiteappApiAuthRegisterPostSchema, RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostParameters, OperationError<RegisterUserLiteappApiAuthRegisterPostError>, TContext>): Array<Mutation<RegisterUserLiteappApiAuthRegisterPostData, RegisterUserLiteappApiAuthRegisterPostError, MutationVariables<RegisterUserLiteappApiAuthRegisterPostBody, RegisterUserLiteappApiAuthRegisterPostParameters>, TContext>>;
        };
        schema: RegisterUserLiteappApiAuthRegisterPostSchema;
        types: {
            parameters: RegisterUserLiteappApiAuthRegisterPostParameters;
            data: RegisterUserLiteappApiAuthRegisterPostData;
            error: RegisterUserLiteappApiAuthRegisterPostError;
            body: RegisterUserLiteappApiAuthRegisterPostBody;
        };
    };
    /** @summary Logout */
    logoutLiteappApiAuthLogoutPost: {
        /** @summary Logout */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters, TMeta, TSignal>, client?: (schema: LogoutLiteappApiAuthLogoutPostSchema, options: ServiceOperationMutationFnOptions<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostError>>): Promise<RequestFnResponse<LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostError>>;
        /** @summary Logout */
        getMutationKey(parameters: DeepReadonly<LogoutLiteappApiAuthLogoutPostParameters> | void): ServiceOperationMutationKey<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends LogoutLiteappApiAuthLogoutPostBody, TContext = unknown>(parameters: DeepReadonly<LogoutLiteappApiAuthLogoutPostParameters>, options?: ServiceOperationUseMutationOptions<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, TVariables, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>): UseMutationResult<LogoutLiteappApiAuthLogoutPostData, OperationError<LogoutLiteappApiAuthLogoutPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useMutation({
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-device-token": xWbsDeviceToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, TVariables, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>): UseMutationResult<LogoutLiteappApiAuthLogoutPostData, OperationError<LogoutLiteappApiAuthLogoutPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const logoutLiteappApiAuthLogoutPostTotal = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const logoutLiteappApiAuthLogoutPostTotal = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const logoutLiteappApiAuthLogoutPostPendingMutationVariables = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const logoutLiteappApiAuthLogoutPostMutationData = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-device-token": xWbsDeviceToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<LogoutLiteappApiAuthLogoutPostData, OperationError<LogoutLiteappApiAuthLogoutPostError>, MutationVariables<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>;
            select?: (mutation: Mutation<LogoutLiteappApiAuthLogoutPostData, OperationError<LogoutLiteappApiAuthLogoutPostError>, MutationVariables<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Logout */
        isMutating<TContext>(filters?: MutationFiltersByParameters<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Logout
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-device-token": xWbsDeviceToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.logoutLiteappApiAuthLogoutPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>): Mutation<LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostError, MutationVariables<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext> | MutationFiltersByMutationKey<LogoutLiteappApiAuthLogoutPostSchema, LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostParameters, OperationError<LogoutLiteappApiAuthLogoutPostError>, TContext>): Array<Mutation<LogoutLiteappApiAuthLogoutPostData, LogoutLiteappApiAuthLogoutPostError, MutationVariables<LogoutLiteappApiAuthLogoutPostBody, LogoutLiteappApiAuthLogoutPostParameters>, TContext>>;
        };
        schema: LogoutLiteappApiAuthLogoutPostSchema;
        types: {
            parameters: LogoutLiteappApiAuthLogoutPostParameters;
            data: LogoutLiteappApiAuthLogoutPostData;
            error: LogoutLiteappApiAuthLogoutPostError;
            body: LogoutLiteappApiAuthLogoutPostBody;
        };
    };
    /** @summary Info */
    infoLiteappApiAppInfoPost: {
        /** @summary Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters, TMeta, TSignal>, client?: (schema: InfoLiteappApiAppInfoPostSchema, options: ServiceOperationMutationFnOptions<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostError>>): Promise<RequestFnResponse<InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostError>>;
        /** @summary Info */
        getMutationKey(parameters: DeepReadonly<InfoLiteappApiAppInfoPostParameters> | void): ServiceOperationMutationKey<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiAppInfoPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiAppInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends InfoLiteappApiAppInfoPostBody, TContext = unknown>(parameters: DeepReadonly<InfoLiteappApiAppInfoPostParameters>, options?: ServiceOperationUseMutationOptions<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, TVariables, OperationError<InfoLiteappApiAppInfoPostError>, TContext>): UseMutationResult<InfoLiteappApiAppInfoPostData, OperationError<InfoLiteappApiAppInfoPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiAppInfoPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiAppInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, TVariables, OperationError<InfoLiteappApiAppInfoPostError>, TContext>): UseMutationResult<InfoLiteappApiAppInfoPostData, OperationError<InfoLiteappApiAppInfoPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const infoLiteappApiAppInfoPostTotal = qraft.liteappApiService.infoLiteappApiAppInfoPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const infoLiteappApiAppInfoPostTotal = qraft.liteappApiService.infoLiteappApiAppInfoPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const infoLiteappApiAppInfoPostPendingMutationVariables = qraft.liteappApiService.infoLiteappApiAppInfoPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const infoLiteappApiAppInfoPostMutationData = qraft.liteappApiService.infoLiteappApiAppInfoPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<InfoLiteappApiAppInfoPostData, OperationError<InfoLiteappApiAppInfoPostError>, MutationVariables<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext>;
            select?: (mutation: Mutation<InfoLiteappApiAppInfoPostData, OperationError<InfoLiteappApiAppInfoPostError>, MutationVariables<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.infoLiteappApiAppInfoPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.infoLiteappApiAppInfoPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext>): Mutation<InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostError, MutationVariables<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiAppInfoPostSchema, InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostParameters, OperationError<InfoLiteappApiAppInfoPostError>, TContext>): Array<Mutation<InfoLiteappApiAppInfoPostData, InfoLiteappApiAppInfoPostError, MutationVariables<InfoLiteappApiAppInfoPostBody, InfoLiteappApiAppInfoPostParameters>, TContext>>;
        };
        schema: InfoLiteappApiAppInfoPostSchema;
        types: {
            parameters: InfoLiteappApiAppInfoPostParameters;
            data: InfoLiteappApiAppInfoPostData;
            error: InfoLiteappApiAppInfoPostError;
            body: InfoLiteappApiAppInfoPostBody;
        };
    };
    /** @summary Register Device */
    registerDeviceLiteappApiDevicesRegisterPost: {
        /** @summary Register Device */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters, TMeta, TSignal>, client?: (schema: RegisterDeviceLiteappApiDevicesRegisterPostSchema, options: ServiceOperationMutationFnOptions<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostError>>): Promise<RequestFnResponse<RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostError>>;
        /** @summary Register Device */
        getMutationKey(parameters: DeepReadonly<RegisterDeviceLiteappApiDevicesRegisterPostParameters> | void): ServiceOperationMutationKey<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends RegisterDeviceLiteappApiDevicesRegisterPostBody, TContext = unknown>(parameters: DeepReadonly<RegisterDeviceLiteappApiDevicesRegisterPostParameters>, options?: ServiceOperationUseMutationOptions<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, TVariables, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>): UseMutationResult<RegisterDeviceLiteappApiDevicesRegisterPostData, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, TVariables, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>): UseMutationResult<RegisterDeviceLiteappApiDevicesRegisterPostData, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const registerDeviceLiteappApiDevicesRegisterPostTotal = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const registerDeviceLiteappApiDevicesRegisterPostTotal = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const registerDeviceLiteappApiDevicesRegisterPostPendingMutationVariables = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const registerDeviceLiteappApiDevicesRegisterPostMutationData = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<RegisterDeviceLiteappApiDevicesRegisterPostData, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, MutationVariables<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>;
            select?: (mutation: Mutation<RegisterDeviceLiteappApiDevicesRegisterPostData, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, MutationVariables<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Register Device */
        isMutating<TContext>(filters?: MutationFiltersByParameters<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Register Device
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.registerDeviceLiteappApiDevicesRegisterPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>): Mutation<RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostError, MutationVariables<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext> | MutationFiltersByMutationKey<RegisterDeviceLiteappApiDevicesRegisterPostSchema, RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostParameters, OperationError<RegisterDeviceLiteappApiDevicesRegisterPostError>, TContext>): Array<Mutation<RegisterDeviceLiteappApiDevicesRegisterPostData, RegisterDeviceLiteappApiDevicesRegisterPostError, MutationVariables<RegisterDeviceLiteappApiDevicesRegisterPostBody, RegisterDeviceLiteappApiDevicesRegisterPostParameters>, TContext>>;
        };
        schema: RegisterDeviceLiteappApiDevicesRegisterPostSchema;
        types: {
            parameters: RegisterDeviceLiteappApiDevicesRegisterPostParameters;
            data: RegisterDeviceLiteappApiDevicesRegisterPostData;
            error: RegisterDeviceLiteappApiDevicesRegisterPostError;
            body: RegisterDeviceLiteappApiDevicesRegisterPostBody;
        };
    };
    /** @summary Init */
    initLiteappApiDownloadsInitPost: {
        /** @summary Init */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters, TMeta, TSignal>, client?: (schema: InitLiteappApiDownloadsInitPostSchema, options: ServiceOperationMutationFnOptions<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostError>>): Promise<RequestFnResponse<InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostError>>;
        /** @summary Init */
        getMutationKey(parameters: DeepReadonly<InitLiteappApiDownloadsInitPostParameters> | void): ServiceOperationMutationKey<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Init
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends InitLiteappApiDownloadsInitPostBody, TContext = unknown>(parameters: DeepReadonly<InitLiteappApiDownloadsInitPostParameters>, options?: ServiceOperationUseMutationOptions<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, TVariables, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>): UseMutationResult<InitLiteappApiDownloadsInitPostData, OperationError<InitLiteappApiDownloadsInitPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Init
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useMutation({})
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useMutation()
         * mutate({
         *     body: bodyPayload
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, TVariables, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>): UseMutationResult<InitLiteappApiDownloadsInitPostData, OperationError<InitLiteappApiDownloadsInitPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Init
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const initLiteappApiDownloadsInitPostTotal = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const initLiteappApiDownloadsInitPostTotal = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useIsMutating({
         *     parameters: {}
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext> | MutationFiltersByMutationKey<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Init
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const initLiteappApiDownloadsInitPostPendingMutationVariables = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const initLiteappApiDownloadsInitPostMutationData = qraft.liteappApiService.initLiteappApiDownloadsInitPost.useMutationState({
         *     filters: {
         *         parameters: {}
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<InitLiteappApiDownloadsInitPostData, OperationError<InitLiteappApiDownloadsInitPostError>, MutationVariables<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext> | MutationFiltersByMutationKey<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>;
            select?: (mutation: Mutation<InitLiteappApiDownloadsInitPostData, OperationError<InitLiteappApiDownloadsInitPostError>, MutationVariables<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Init */
        isMutating<TContext>(filters?: MutationFiltersByParameters<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext> | MutationFiltersByMutationKey<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Init
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.initLiteappApiDownloadsInitPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {}
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.initLiteappApiDownloadsInitPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext> | MutationFiltersByMutationKey<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>): Mutation<InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostError, MutationVariables<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext> | MutationFiltersByMutationKey<InitLiteappApiDownloadsInitPostSchema, InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostParameters, OperationError<InitLiteappApiDownloadsInitPostError>, TContext>): Array<Mutation<InitLiteappApiDownloadsInitPostData, InitLiteappApiDownloadsInitPostError, MutationVariables<InitLiteappApiDownloadsInitPostBody, InitLiteappApiDownloadsInitPostParameters>, TContext>>;
        };
        schema: InitLiteappApiDownloadsInitPostSchema;
        types: {
            parameters: InitLiteappApiDownloadsInitPostParameters;
            data: InitLiteappApiDownloadsInitPostData;
            error: InitLiteappApiDownloadsInitPostError;
            body: InitLiteappApiDownloadsInitPostBody;
        };
    };
    /** @summary Types */
    typesLiteappApiDownloadsTypesPost: {
        /** @summary Types */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters, TMeta, TSignal>, client?: (schema: TypesLiteappApiDownloadsTypesPostSchema, options: ServiceOperationMutationFnOptions<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostError>>): Promise<RequestFnResponse<TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostError>>;
        /** @summary Types */
        getMutationKey(parameters: DeepReadonly<TypesLiteappApiDownloadsTypesPostParameters> | void): ServiceOperationMutationKey<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Types
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TypesLiteappApiDownloadsTypesPostBody, TContext = unknown>(parameters: DeepReadonly<TypesLiteappApiDownloadsTypesPostParameters>, options?: ServiceOperationUseMutationOptions<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, TVariables, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>): UseMutationResult<TypesLiteappApiDownloadsTypesPostData, OperationError<TypesLiteappApiDownloadsTypesPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Types
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, TVariables, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>): UseMutationResult<TypesLiteappApiDownloadsTypesPostData, OperationError<TypesLiteappApiDownloadsTypesPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Types
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const typesLiteappApiDownloadsTypesPostTotal = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const typesLiteappApiDownloadsTypesPostTotal = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext> | MutationFiltersByMutationKey<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Types
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const typesLiteappApiDownloadsTypesPostPendingMutationVariables = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const typesLiteappApiDownloadsTypesPostMutationData = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TypesLiteappApiDownloadsTypesPostData, OperationError<TypesLiteappApiDownloadsTypesPostError>, MutationVariables<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext> | MutationFiltersByMutationKey<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>;
            select?: (mutation: Mutation<TypesLiteappApiDownloadsTypesPostData, OperationError<TypesLiteappApiDownloadsTypesPostError>, MutationVariables<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Types */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext> | MutationFiltersByMutationKey<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Types
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.typesLiteappApiDownloadsTypesPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext> | MutationFiltersByMutationKey<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>): Mutation<TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostError, MutationVariables<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext> | MutationFiltersByMutationKey<TypesLiteappApiDownloadsTypesPostSchema, TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostParameters, OperationError<TypesLiteappApiDownloadsTypesPostError>, TContext>): Array<Mutation<TypesLiteappApiDownloadsTypesPostData, TypesLiteappApiDownloadsTypesPostError, MutationVariables<TypesLiteappApiDownloadsTypesPostBody, TypesLiteappApiDownloadsTypesPostParameters>, TContext>>;
        };
        schema: TypesLiteappApiDownloadsTypesPostSchema;
        types: {
            parameters: TypesLiteappApiDownloadsTypesPostParameters;
            data: TypesLiteappApiDownloadsTypesPostData;
            error: TypesLiteappApiDownloadsTypesPostError;
            body: TypesLiteappApiDownloadsTypesPostBody;
        };
    };
    /** @summary Download Zip */
    downloadZipLiteappApiDownloadsNameZipGet: {
        /** @summary Download Zip */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: QueryFnOptionsByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters, TMeta, TSignal> | (QueryFnOptionsByParameters<DownloadZipLiteappApiDownloadsNameZipGetParameters, TMeta, TSignal>), client?: (schema: DownloadZipLiteappApiDownloadsNameZipGetSchema, options: {
            parameters: DownloadZipLiteappApiDownloadsNameZipGetParameters;
            signal?: TSignal;
            meta?: TMeta;
        }) => Promise<RequestFnResponse<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>): Promise<RequestFnResponse<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /** @summary Download Zip */
        getQueryKey(parameters: DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>): ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useQuery({
         *     path: {
         *         name: name
         *     }
         * })
         * ```
         */
        useQuery<TData = DownloadZipLiteappApiDownloadsNameZipGetData>(parameters: ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>), options?: Omit<UndefinedInitialDataOptions<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError, TData, ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>>, "queryKey">): UseQueryResult<TData, OperationError<DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /**
         * Performs asynchronous data fetching, manages loading states and error handling.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
         * @example Query with parameters
         * ```ts
         * const { data, isLoading } = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useQuery({
         *     path: {
         *         name: name
         *     }
         * })
         * ```
         */
        useQuery<TData = DownloadZipLiteappApiDownloadsNameZipGetData>(parameters: ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>), options: Omit<DefinedInitialDataOptions<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError, TData, ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>>, "queryKey">): DefinedUseQueryResult<TData, OperationError<DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /** @summary Download Zip */
        getInfiniteQueryKey(parameters: DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>): ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useInfiniteQuery({
         *     path: {
         *         name: name
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends DownloadZipLiteappApiDownloadsNameZipGetParameters, TQueryFnData = DownloadZipLiteappApiDownloadsNameZipGetData, TData = OperationInfiniteData<TQueryFnData, DownloadZipLiteappApiDownloadsNameZipGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>), options: Omit<UndefinedInitialDataInfiniteOptions<TQueryFnData, DownloadZipLiteappApiDownloadsNameZipGetError, TData, ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>): UseInfiniteQueryResult<TData, OperationError<DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
         *
         * @example Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useInfiniteQuery({
         *     path: {
         *         name: name
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useInfiniteQuery<TPageParam extends DownloadZipLiteappApiDownloadsNameZipGetParameters, TQueryFnData = DownloadZipLiteappApiDownloadsNameZipGetData, TData = OperationInfiniteData<TQueryFnData, DownloadZipLiteappApiDownloadsNameZipGetParameters>>(parameters: ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>), options: Omit<DefinedInitialDataInfiniteOptions<TQueryFnData, DownloadZipLiteappApiDownloadsNameZipGetError, TData, ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<DownloadZipLiteappApiDownloadsNameZipGetData, PartialParameters<DeepReadonly<TPageParam>>>): DefinedUseInfiniteQueryResult<TData, OperationError<DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /**
         * Monitors the number of queries currently fetching, matching the provided filters.
         * Useful for creating loading indicators or performing actions based on active requests.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
         * @example Checks the total number of queries fetching from the specified service method,
         * both normal and infinite. If no parameters are provided, no filtering is applied.
         * ```ts
         * const downloadZipLiteappApiDownloadsNameZipGetTotal = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useIsFetching()
         * ```
         * @example Checks the number of normal queries fetching with the specified parameters.
         * ```ts
         * const downloadZipLiteappApiDownloadsNameZipGetByParametersTotal = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useIsFetching({
         *     infinite: false,
         *     parameters: {
         *         path: {
         *             name: name
         *         }
         *     }
         * })
         * ```
         */
        useIsFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): number;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
         * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
         * ```ts
         * const downloadZipLiteappApiDownloadsNameZipGetResults = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useQueries({
         *     queries: [
         *         {
         *             path: {
         *                 name: name1
         *             }
         *         },
         *         {
         *             path: {
         *                 name: name2
         *             }
         *         }
         *     ]
         * });
         * downloadZipLiteappApiDownloadsNameZipGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example Combined results. Only the data will be returned.
         * ```ts
         * const downloadZipLiteappApiDownloadsNameZipGetCombinedResults = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 name: name1
         *             }
         *         },
         *         {
         *             path: {
         *                 name: name2
         *             }
         *         }
         *     ]
         * });
         * downloadZipLiteappApiDownloadsNameZipGetCombinedResults.forEach(data => console.log({ data }));
         * ```
         */
        useQueries<T extends Array<UseQueryOptionsForUseQueries<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>, TCombinedResult = Array<UseQueryResult<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>>(options: {
            queries: T;
            combine?: (results: Array<UseQueryResult<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>) => TCombinedResult;
        }): TCombinedResult;
        /**
         * Performs asynchronous data fetching with Suspense support.
         * Similar to useQuery but integrates with React Suspense for loading states.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
         * @example Suspense Query with parameters
         * ```ts
         * const data = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useSuspenseQuery({
         *     path: {
         *         name: name
         *     }
         * })
         * ```
         */
        useSuspenseQuery<TData = DownloadZipLiteappApiDownloadsNameZipGetData>(parameters: ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>), options?: Omit<UseSuspenseQueryOptions<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError, TData, ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>>, "queryKey">): UseSuspenseQueryResult<TData, OperationError<DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /**
         * Performs asynchronous data fetching with support for infinite scrolling scenarios.
         * Manages paginated data and provides utilities for fetching additional pages.
         * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
         *
         * @example Suspense Infinite Query
         * ```ts
         * const { data, isLoading, fetchNextPage } = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useSuspenseInfiniteQuery({
         *     path: {
         *         name: name
         *     }
         * }, {
         *     initialPageParam: {},
         *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
         * })
         *
         * console.log(data);
         * fetchNextPage(); // Fetch the next page
         * ```
         */
        useSuspenseInfiniteQuery<TPageParam extends DownloadZipLiteappApiDownloadsNameZipGetParameters, TData = DownloadZipLiteappApiDownloadsNameZipGetData>(parameters: ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>), options: Omit<UseSuspenseInfiniteQueryOptions<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError, OperationInfiniteData<TData, DownloadZipLiteappApiDownloadsNameZipGetParameters>, ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>, PartialParameters<DeepReadonly<TPageParam>>>, "queryKey" | "getPreviousPageParam" | "getNextPageParam" | "initialPageParam"> & InfiniteQueryPageParamsOptions<DownloadZipLiteappApiDownloadsNameZipGetData, PartialParameters<DeepReadonly<TPageParam>>>): UseSuspenseInfiniteQueryResult<OperationInfiniteData<TData, DownloadZipLiteappApiDownloadsNameZipGetParameters>, OperationError<DownloadZipLiteappApiDownloadsNameZipGetError>>;
        /**
         * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
         * Similar to useQueries but integrates with React Suspense for loading states.
         *
         * @summary Download Zip
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
         * @example Basic usage with Suspense
         * ```ts
         * const downloadZipLiteappApiDownloadsNameZipGetData = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useSuspenseQueries({
         *     queries: [
         *         {
         *             path: {
         *                 name: name1
         *             }
         *         },
         *         {
         *             path: {
         *                 name: name2
         *             }
         *         }
         *     ]
         * });
         * downloadZipLiteappApiDownloadsNameZipGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
         * ```
         * @example With data transformation using combine
         * ```ts
         * const downloadZipLiteappApiDownloadsNameZipGetCombinedData = qraft.liteappApiService.downloadZipLiteappApiDownloadsNameZipGet.useSuspenseQueries({
         *     combine: results => results.map(result => result.data),
         *     queries: [
         *         {
         *             path: {
         *                 name: name1
         *             }
         *         },
         *         {
         *             path: {
         *                 name: name2
         *             }
         *         }
         *     ]
         * });
         * downloadZipLiteappApiDownloadsNameZipGetCombinedData.forEach(data => console.log({ data }));
         * ```
         */
        useSuspenseQueries<T extends Array<UseQueryOptionsForUseSuspenseQuery<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>, TCombinedResult = Array<UseSuspenseQueryResult<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>>>(options: {
            queries: T;
            combine?: (results: Array<WithOptional<UseSuspenseQueryResult<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError>, "data">>) => TCombinedResult;
        }): TCombinedResult;
        /** @summary Download Zip */
        fetchQuery(options: ServiceOperationFetchQueryOptions<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): Promise<DownloadZipLiteappApiDownloadsNameZipGetData>;
        /** @summary Download Zip */
        prefetchQuery(options: ServiceOperationFetchQueryOptions<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): Promise<void>;
        /** @summary Download Zip */
        ensureQueryData(options: ServiceOperationEnsureQueryDataOptions<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): Promise<DownloadZipLiteappApiDownloadsNameZipGetData>;
        /** @summary Download Zip */
        fetchInfiniteQuery<TPageParam extends DownloadZipLiteappApiDownloadsNameZipGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters, DeepReadonly<TPageParam>, DownloadZipLiteappApiDownloadsNameZipGetError>): Promise<OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters>>;
        /** @summary Download Zip */
        prefetchInfiniteQuery<TPageParam extends DownloadZipLiteappApiDownloadsNameZipGetParameters>(options: ServiceOperationFetchInfiniteQueryOptions<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters, DeepReadonly<TPageParam>, DownloadZipLiteappApiDownloadsNameZipGetError>): Promise<void>;
        /** @summary Download Zip */
        ensureInfiniteQueryData<TPageParam extends DownloadZipLiteappApiDownloadsNameZipGetParameters>(options: ServiceOperationEnsureInfiniteQueryDataOptions<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters, DeepReadonly<TPageParam>, DownloadZipLiteappApiDownloadsNameZipGetError>): Promise<OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters>>;
        /** @summary Download Zip */
        getQueryData(parameters: ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>)): DownloadZipLiteappApiDownloadsNameZipGetData | undefined;
        /** @summary Download Zip */
        getInfiniteQueryData(parameters: ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>)): OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters> | undefined;
        /** @summary Download Zip */
        getQueriesData<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): TInfinite extends true ? Array<[
            queryKey: ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>,
            data: NoInfer<OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters>> | undefined
        ]> : Array<[
            queryKey: ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>,
            data: DownloadZipLiteappApiDownloadsNameZipGetData | undefined
        ]>;
        /** @summary Download Zip */
        getQueryState(parameters: ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters> | (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>)): QueryState<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetError> | undefined;
        /** @summary Download Zip */
        getInfiniteQueryState(parameters: DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters> | ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>): QueryState<OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters>, DownloadZipLiteappApiDownloadsNameZipGetError> | undefined;
        /** @summary Download Zip */
        setQueryData(parameters: (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>) | ServiceOperationQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>, updater: Updater<NoInfer<DownloadZipLiteappApiDownloadsNameZipGetData> | undefined, NoInfer<DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetData>> | undefined>, options?: SetDataOptions): DownloadZipLiteappApiDownloadsNameZipGetData | undefined;
        /** @summary Download Zip */
        setInfiniteQueryData(parameters: (DeepReadonly<DownloadZipLiteappApiDownloadsNameZipGetParameters>) | ServiceOperationInfiniteQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetParameters>, updater: Updater<NoInfer<OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters>> | undefined, NoInfer<DeepReadonly<OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters>>> | undefined>, options?: SetDataOptions): OperationInfiniteData<DownloadZipLiteappApiDownloadsNameZipGetData, DownloadZipLiteappApiDownloadsNameZipGetParameters> | undefined;
        /** @summary Download Zip */
        setQueriesData<TInfinite extends boolean = false>(filters: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>, updater: Updater<NoInfer<DownloadZipLiteappApiDownloadsNameZipGetData> | undefined, NoInfer<DownloadZipLiteappApiDownloadsNameZipGetData> | undefined>, options?: SetDataOptions): Array<DownloadZipLiteappApiDownloadsNameZipGetData | undefined>;
        /** @summary Download Zip */
        invalidateQueries<TInfinite extends boolean = false>(filters?: InvalidateQueryFilters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>, options?: InvalidateOptions): Promise<void>;
        /** @summary Download Zip */
        refetchQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>, options?: RefetchOptions): Promise<void>;
        /** @summary Download Zip */
        cancelQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>, options?: CancelOptions): Promise<void>;
        /** @summary Download Zip */
        removeQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): void;
        /** @summary Download Zip */
        resetQueries<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>, options?: ResetOptions): Promise<void>;
        /** @summary Download Zip */
        isFetching<TInfinite extends boolean = false>(filters?: QueryFiltersByParameters<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError> | QueryFiltersByQueryKey<DownloadZipLiteappApiDownloadsNameZipGetSchema, DownloadZipLiteappApiDownloadsNameZipGetData, TInfinite, DownloadZipLiteappApiDownloadsNameZipGetParameters, DownloadZipLiteappApiDownloadsNameZipGetError>): number;
        schema: DownloadZipLiteappApiDownloadsNameZipGetSchema;
        types: {
            parameters: DownloadZipLiteappApiDownloadsNameZipGetParameters;
            data: DownloadZipLiteappApiDownloadsNameZipGetData;
            error: DownloadZipLiteappApiDownloadsNameZipGetError;
        };
    };
    /** @summary Translations */
    translationsLiteappApiLanguagesTranslationsPost: {
        /** @summary Translations */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters, TMeta, TSignal>, client?: (schema: TranslationsLiteappApiLanguagesTranslationsPostSchema, options: ServiceOperationMutationFnOptions<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostError>>): Promise<RequestFnResponse<TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostError>>;
        /** @summary Translations */
        getMutationKey(parameters: DeepReadonly<TranslationsLiteappApiLanguagesTranslationsPostParameters> | void): ServiceOperationMutationKey<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TranslationsLiteappApiLanguagesTranslationsPostBody, TContext = unknown>(parameters: DeepReadonly<TranslationsLiteappApiLanguagesTranslationsPostParameters>, options?: ServiceOperationUseMutationOptions<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, TVariables, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>): UseMutationResult<TranslationsLiteappApiLanguagesTranslationsPostData, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, TVariables, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>): UseMutationResult<TranslationsLiteappApiLanguagesTranslationsPostData, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const translationsLiteappApiLanguagesTranslationsPostTotal = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const translationsLiteappApiLanguagesTranslationsPostTotal = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const translationsLiteappApiLanguagesTranslationsPostPendingMutationVariables = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const translationsLiteappApiLanguagesTranslationsPostMutationData = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TranslationsLiteappApiLanguagesTranslationsPostData, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, MutationVariables<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>;
            select?: (mutation: Mutation<TranslationsLiteappApiLanguagesTranslationsPostData, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, MutationVariables<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Translations */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Translations
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.translationsLiteappApiLanguagesTranslationsPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>): Mutation<TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostError, MutationVariables<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext> | MutationFiltersByMutationKey<TranslationsLiteappApiLanguagesTranslationsPostSchema, TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostParameters, OperationError<TranslationsLiteappApiLanguagesTranslationsPostError>, TContext>): Array<Mutation<TranslationsLiteappApiLanguagesTranslationsPostData, TranslationsLiteappApiLanguagesTranslationsPostError, MutationVariables<TranslationsLiteappApiLanguagesTranslationsPostBody, TranslationsLiteappApiLanguagesTranslationsPostParameters>, TContext>>;
        };
        schema: TranslationsLiteappApiLanguagesTranslationsPostSchema;
        types: {
            parameters: TranslationsLiteappApiLanguagesTranslationsPostParameters;
            data: TranslationsLiteappApiLanguagesTranslationsPostData;
            error: TranslationsLiteappApiLanguagesTranslationsPostError;
            body: TranslationsLiteappApiLanguagesTranslationsPostBody;
        };
    };
    /** @summary Detail */
    detailLiteappApiPagesDetailPost: {
        /** @summary Detail */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters, TMeta, TSignal>, client?: (schema: DetailLiteappApiPagesDetailPostSchema, options: ServiceOperationMutationFnOptions<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostError>>): Promise<RequestFnResponse<DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostError>>;
        /** @summary Detail */
        getMutationKey(parameters: DeepReadonly<DetailLiteappApiPagesDetailPostParameters> | void): ServiceOperationMutationKey<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DetailLiteappApiPagesDetailPostBody, TContext = unknown>(parameters: DeepReadonly<DetailLiteappApiPagesDetailPostParameters>, options?: ServiceOperationUseMutationOptions<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, TVariables, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>): UseMutationResult<DetailLiteappApiPagesDetailPostData, OperationError<DetailLiteappApiPagesDetailPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useMutation({
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-language": xWbsLanguage
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, TVariables, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>): UseMutationResult<DetailLiteappApiPagesDetailPostData, OperationError<DetailLiteappApiPagesDetailPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const detailLiteappApiPagesDetailPostTotal = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const detailLiteappApiPagesDetailPostTotal = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const detailLiteappApiPagesDetailPostPendingMutationVariables = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const detailLiteappApiPagesDetailPostMutationData = qraft.liteappApiService.detailLiteappApiPagesDetailPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-language": xWbsLanguage
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DetailLiteappApiPagesDetailPostData, OperationError<DetailLiteappApiPagesDetailPostError>, MutationVariables<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>;
            select?: (mutation: Mutation<DetailLiteappApiPagesDetailPostData, OperationError<DetailLiteappApiPagesDetailPostError>, MutationVariables<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Detail */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Detail
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.detailLiteappApiPagesDetailPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-language": xWbsLanguage
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.detailLiteappApiPagesDetailPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>): Mutation<DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostError, MutationVariables<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext> | MutationFiltersByMutationKey<DetailLiteappApiPagesDetailPostSchema, DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostParameters, OperationError<DetailLiteappApiPagesDetailPostError>, TContext>): Array<Mutation<DetailLiteappApiPagesDetailPostData, DetailLiteappApiPagesDetailPostError, MutationVariables<DetailLiteappApiPagesDetailPostBody, DetailLiteappApiPagesDetailPostParameters>, TContext>>;
        };
        schema: DetailLiteappApiPagesDetailPostSchema;
        types: {
            parameters: DetailLiteappApiPagesDetailPostParameters;
            data: DetailLiteappApiPagesDetailPostData;
            error: DetailLiteappApiPagesDetailPostError;
            body: DetailLiteappApiPagesDetailPostBody;
        };
    };
    /** @summary Me */
    meLiteappApiUsersMePost: {
        /** @summary Me */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters, TMeta, TSignal>, client?: (schema: MeLiteappApiUsersMePostSchema, options: ServiceOperationMutationFnOptions<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostError>>): Promise<RequestFnResponse<MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostError>>;
        /** @summary Me */
        getMutationKey(parameters: DeepReadonly<MeLiteappApiUsersMePostParameters> | void): ServiceOperationMutationKey<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.meLiteappApiUsersMePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.meLiteappApiUsersMePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MeLiteappApiUsersMePostBody, TContext = unknown>(parameters: DeepReadonly<MeLiteappApiUsersMePostParameters>, options?: ServiceOperationUseMutationOptions<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, TVariables, OperationError<MeLiteappApiUsersMePostError>, TContext>): UseMutationResult<MeLiteappApiUsersMePostData, OperationError<MeLiteappApiUsersMePostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.meLiteappApiUsersMePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.meLiteappApiUsersMePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, TVariables, OperationError<MeLiteappApiUsersMePostError>, TContext>): UseMutationResult<MeLiteappApiUsersMePostData, OperationError<MeLiteappApiUsersMePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const meLiteappApiUsersMePostTotal = qraft.liteappApiService.meLiteappApiUsersMePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const meLiteappApiUsersMePostTotal = qraft.liteappApiService.meLiteappApiUsersMePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const meLiteappApiUsersMePostPendingMutationVariables = qraft.liteappApiService.meLiteappApiUsersMePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const meLiteappApiUsersMePostMutationData = qraft.liteappApiService.meLiteappApiUsersMePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<MeLiteappApiUsersMePostData, OperationError<MeLiteappApiUsersMePostError>, MutationVariables<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext>;
            select?: (mutation: Mutation<MeLiteappApiUsersMePostData, OperationError<MeLiteappApiUsersMePostError>, MutationVariables<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Me */
        isMutating<TContext>(filters?: MutationFiltersByParameters<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Me
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.meLiteappApiUsersMePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.meLiteappApiUsersMePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext>): Mutation<MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostError, MutationVariables<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext> | MutationFiltersByMutationKey<MeLiteappApiUsersMePostSchema, MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostParameters, OperationError<MeLiteappApiUsersMePostError>, TContext>): Array<Mutation<MeLiteappApiUsersMePostData, MeLiteappApiUsersMePostError, MutationVariables<MeLiteappApiUsersMePostBody, MeLiteappApiUsersMePostParameters>, TContext>>;
        };
        schema: MeLiteappApiUsersMePostSchema;
        types: {
            parameters: MeLiteappApiUsersMePostParameters;
            data: MeLiteappApiUsersMePostData;
            error: MeLiteappApiUsersMePostError;
            body: MeLiteappApiUsersMePostBody;
        };
    };
    /** @summary Info */
    infoLiteappApiUsersInfoPost: {
        /** @summary Info */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters, TMeta, TSignal>, client?: (schema: InfoLiteappApiUsersInfoPostSchema, options: ServiceOperationMutationFnOptions<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostError>>): Promise<RequestFnResponse<InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostError>>;
        /** @summary Info */
        getMutationKey(parameters: DeepReadonly<InfoLiteappApiUsersInfoPostParameters> | void): ServiceOperationMutationKey<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends InfoLiteappApiUsersInfoPostBody, TContext = unknown>(parameters: DeepReadonly<InfoLiteappApiUsersInfoPostParameters>, options?: ServiceOperationUseMutationOptions<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, TVariables, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>): UseMutationResult<InfoLiteappApiUsersInfoPostData, OperationError<InfoLiteappApiUsersInfoPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, TVariables, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>): UseMutationResult<InfoLiteappApiUsersInfoPostData, OperationError<InfoLiteappApiUsersInfoPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const infoLiteappApiUsersInfoPostTotal = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const infoLiteappApiUsersInfoPostTotal = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const infoLiteappApiUsersInfoPostPendingMutationVariables = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const infoLiteappApiUsersInfoPostMutationData = qraft.liteappApiService.infoLiteappApiUsersInfoPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<InfoLiteappApiUsersInfoPostData, OperationError<InfoLiteappApiUsersInfoPostError>, MutationVariables<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>;
            select?: (mutation: Mutation<InfoLiteappApiUsersInfoPostData, OperationError<InfoLiteappApiUsersInfoPostError>, MutationVariables<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Info */
        isMutating<TContext>(filters?: MutationFiltersByParameters<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Info
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.infoLiteappApiUsersInfoPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.infoLiteappApiUsersInfoPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>): Mutation<InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostError, MutationVariables<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext> | MutationFiltersByMutationKey<InfoLiteappApiUsersInfoPostSchema, InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostParameters, OperationError<InfoLiteappApiUsersInfoPostError>, TContext>): Array<Mutation<InfoLiteappApiUsersInfoPostData, InfoLiteappApiUsersInfoPostError, MutationVariables<InfoLiteappApiUsersInfoPostBody, InfoLiteappApiUsersInfoPostParameters>, TContext>>;
        };
        schema: InfoLiteappApiUsersInfoPostSchema;
        types: {
            parameters: InfoLiteappApiUsersInfoPostParameters;
            data: InfoLiteappApiUsersInfoPostData;
            error: InfoLiteappApiUsersInfoPostError;
            body: InfoLiteappApiUsersInfoPostBody;
        };
    };
    /** @summary Submit */
    submitLiteappApiOnboardingsSubmitPost: {
        /** @summary Submit */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters, TMeta, TSignal>, client?: (schema: SubmitLiteappApiOnboardingsSubmitPostSchema, options: ServiceOperationMutationFnOptions<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostError>>): Promise<RequestFnResponse<SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostError>>;
        /** @summary Submit */
        getMutationKey(parameters: DeepReadonly<SubmitLiteappApiOnboardingsSubmitPostParameters> | void): ServiceOperationMutationKey<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SubmitLiteappApiOnboardingsSubmitPostBody, TContext = unknown>(parameters: DeepReadonly<SubmitLiteappApiOnboardingsSubmitPostParameters>, options?: ServiceOperationUseMutationOptions<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, TVariables, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>): UseMutationResult<SubmitLiteappApiOnboardingsSubmitPostData, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, TVariables, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>): UseMutationResult<SubmitLiteappApiOnboardingsSubmitPostData, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const submitLiteappApiOnboardingsSubmitPostTotal = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const submitLiteappApiOnboardingsSubmitPostTotal = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const submitLiteappApiOnboardingsSubmitPostPendingMutationVariables = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const submitLiteappApiOnboardingsSubmitPostMutationData = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SubmitLiteappApiOnboardingsSubmitPostData, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, MutationVariables<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>;
            select?: (mutation: Mutation<SubmitLiteappApiOnboardingsSubmitPostData, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, MutationVariables<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Submit */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.submitLiteappApiOnboardingsSubmitPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>): Mutation<SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostError, MutationVariables<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext> | MutationFiltersByMutationKey<SubmitLiteappApiOnboardingsSubmitPostSchema, SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostParameters, OperationError<SubmitLiteappApiOnboardingsSubmitPostError>, TContext>): Array<Mutation<SubmitLiteappApiOnboardingsSubmitPostData, SubmitLiteappApiOnboardingsSubmitPostError, MutationVariables<SubmitLiteappApiOnboardingsSubmitPostBody, SubmitLiteappApiOnboardingsSubmitPostParameters>, TContext>>;
        };
        schema: SubmitLiteappApiOnboardingsSubmitPostSchema;
        types: {
            parameters: SubmitLiteappApiOnboardingsSubmitPostParameters;
            data: SubmitLiteappApiOnboardingsSubmitPostData;
            error: SubmitLiteappApiOnboardingsSubmitPostError;
            body: SubmitLiteappApiOnboardingsSubmitPostBody;
        };
    };
    /** @summary Topics Mark Complete */
    topicsMarkCompleteLiteappApiTopicsMarkCompletePost: {
        /** @summary Topics Mark Complete */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, TMeta, TSignal>, client?: (schema: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, options: ServiceOperationMutationFnOptions<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>>): Promise<RequestFnResponse<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>>;
        /** @summary Topics Mark Complete */
        getMutationKey(parameters: DeepReadonly<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters> | void): ServiceOperationMutationKey<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topics Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TContext = unknown>(parameters: DeepReadonly<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>, options?: ServiceOperationUseMutationOptions<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, TVariables, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>): UseMutationResult<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Topics Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, TVariables, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>): UseMutationResult<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Topics Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const topicsMarkCompleteLiteappApiTopicsMarkCompletePostTotal = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const topicsMarkCompleteLiteappApiTopicsMarkCompletePostTotal = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Topics Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const topicsMarkCompleteLiteappApiTopicsMarkCompletePostPendingMutationVariables = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const topicsMarkCompleteLiteappApiTopicsMarkCompletePostMutationData = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, MutationVariables<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>;
            select?: (mutation: Mutation<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, MutationVariables<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Topics Mark Complete */
        isMutating<TContext>(filters?: MutationFiltersByParameters<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Topics Mark Complete
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.topicsMarkCompleteLiteappApiTopicsMarkCompletePost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>): Mutation<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError, MutationVariables<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext> | MutationFiltersByMutationKey<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters, OperationError<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError>, TContext>): Array<Mutation<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError, MutationVariables<TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody, TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters>, TContext>>;
        };
        schema: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema;
        types: {
            parameters: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters;
            data: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData;
            error: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError;
            body: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody;
        };
    };
    /** @summary Quizzes Submit */
    quizzesSubmitLiteappApiQuizzesSubmitPost: {
        /** @summary Quizzes Submit */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, TMeta, TSignal>, client?: (schema: QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, options: ServiceOperationMutationFnOptions<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostError>>): Promise<RequestFnResponse<QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostError>>;
        /** @summary Quizzes Submit */
        getMutationKey(parameters: DeepReadonly<QuizzesSubmitLiteappApiQuizzesSubmitPostParameters> | void): ServiceOperationMutationKey<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Quizzes Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends QuizzesSubmitLiteappApiQuizzesSubmitPostBody, TContext = unknown>(parameters: DeepReadonly<QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>, options?: ServiceOperationUseMutationOptions<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, TVariables, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>): UseMutationResult<QuizzesSubmitLiteappApiQuizzesSubmitPostData, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Quizzes Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, TVariables, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>): UseMutationResult<QuizzesSubmitLiteappApiQuizzesSubmitPostData, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Quizzes Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const quizzesSubmitLiteappApiQuizzesSubmitPostTotal = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const quizzesSubmitLiteappApiQuizzesSubmitPostTotal = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Quizzes Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const quizzesSubmitLiteappApiQuizzesSubmitPostPendingMutationVariables = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const quizzesSubmitLiteappApiQuizzesSubmitPostMutationData = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<QuizzesSubmitLiteappApiQuizzesSubmitPostData, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, MutationVariables<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>;
            select?: (mutation: Mutation<QuizzesSubmitLiteappApiQuizzesSubmitPostData, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, MutationVariables<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Quizzes Submit */
        isMutating<TContext>(filters?: MutationFiltersByParameters<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Quizzes Submit
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.quizzesSubmitLiteappApiQuizzesSubmitPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>): Mutation<QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostError, MutationVariables<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext> | MutationFiltersByMutationKey<QuizzesSubmitLiteappApiQuizzesSubmitPostSchema, QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters, OperationError<QuizzesSubmitLiteappApiQuizzesSubmitPostError>, TContext>): Array<Mutation<QuizzesSubmitLiteappApiQuizzesSubmitPostData, QuizzesSubmitLiteappApiQuizzesSubmitPostError, MutationVariables<QuizzesSubmitLiteappApiQuizzesSubmitPostBody, QuizzesSubmitLiteappApiQuizzesSubmitPostParameters>, TContext>>;
        };
        schema: QuizzesSubmitLiteappApiQuizzesSubmitPostSchema;
        types: {
            parameters: QuizzesSubmitLiteappApiQuizzesSubmitPostParameters;
            data: QuizzesSubmitLiteappApiQuizzesSubmitPostData;
            error: QuizzesSubmitLiteappApiQuizzesSubmitPostError;
            body: QuizzesSubmitLiteappApiQuizzesSubmitPostBody;
        };
    };
    /** @summary Fetch */
    fetchLiteappApiNotificationsFetchPost: {
        /** @summary Fetch */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters, TMeta, TSignal>, client?: (schema: FetchLiteappApiNotificationsFetchPostSchema, options: ServiceOperationMutationFnOptions<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostError>>): Promise<RequestFnResponse<FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostError>>;
        /** @summary Fetch */
        getMutationKey(parameters: DeepReadonly<FetchLiteappApiNotificationsFetchPostParameters> | void): ServiceOperationMutationKey<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FetchLiteappApiNotificationsFetchPostBody, TContext = unknown>(parameters: DeepReadonly<FetchLiteappApiNotificationsFetchPostParameters>, options?: ServiceOperationUseMutationOptions<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, TVariables, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>): UseMutationResult<FetchLiteappApiNotificationsFetchPostData, OperationError<FetchLiteappApiNotificationsFetchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, TVariables, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>): UseMutationResult<FetchLiteappApiNotificationsFetchPostData, OperationError<FetchLiteappApiNotificationsFetchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fetchLiteappApiNotificationsFetchPostTotal = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fetchLiteappApiNotificationsFetchPostTotal = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fetchLiteappApiNotificationsFetchPostPendingMutationVariables = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fetchLiteappApiNotificationsFetchPostMutationData = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FetchLiteappApiNotificationsFetchPostData, OperationError<FetchLiteappApiNotificationsFetchPostError>, MutationVariables<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>;
            select?: (mutation: Mutation<FetchLiteappApiNotificationsFetchPostData, OperationError<FetchLiteappApiNotificationsFetchPostError>, MutationVariables<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fetch */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.fetchLiteappApiNotificationsFetchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>): Mutation<FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostError, MutationVariables<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiNotificationsFetchPostSchema, FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostParameters, OperationError<FetchLiteappApiNotificationsFetchPostError>, TContext>): Array<Mutation<FetchLiteappApiNotificationsFetchPostData, FetchLiteappApiNotificationsFetchPostError, MutationVariables<FetchLiteappApiNotificationsFetchPostBody, FetchLiteappApiNotificationsFetchPostParameters>, TContext>>;
        };
        schema: FetchLiteappApiNotificationsFetchPostSchema;
        types: {
            parameters: FetchLiteappApiNotificationsFetchPostParameters;
            data: FetchLiteappApiNotificationsFetchPostData;
            error: FetchLiteappApiNotificationsFetchPostError;
            body: FetchLiteappApiNotificationsFetchPostBody;
        };
    };
    /** @summary Fetch */
    fetchLiteappApiSubmissionsFetchPost: {
        /** @summary Fetch */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters, TMeta, TSignal>, client?: (schema: FetchLiteappApiSubmissionsFetchPostSchema, options: ServiceOperationMutationFnOptions<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostError>>): Promise<RequestFnResponse<FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostError>>;
        /** @summary Fetch */
        getMutationKey(parameters: DeepReadonly<FetchLiteappApiSubmissionsFetchPostParameters> | void): ServiceOperationMutationKey<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends FetchLiteappApiSubmissionsFetchPostBody, TContext = unknown>(parameters: DeepReadonly<FetchLiteappApiSubmissionsFetchPostParameters>, options?: ServiceOperationUseMutationOptions<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, TVariables, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>): UseMutationResult<FetchLiteappApiSubmissionsFetchPostData, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, TVariables, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>): UseMutationResult<FetchLiteappApiSubmissionsFetchPostData, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const fetchLiteappApiSubmissionsFetchPostTotal = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const fetchLiteappApiSubmissionsFetchPostTotal = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const fetchLiteappApiSubmissionsFetchPostPendingMutationVariables = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const fetchLiteappApiSubmissionsFetchPostMutationData = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<FetchLiteappApiSubmissionsFetchPostData, OperationError<FetchLiteappApiSubmissionsFetchPostError>, MutationVariables<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>;
            select?: (mutation: Mutation<FetchLiteappApiSubmissionsFetchPostData, OperationError<FetchLiteappApiSubmissionsFetchPostError>, MutationVariables<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Fetch */
        isMutating<TContext>(filters?: MutationFiltersByParameters<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Fetch
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.fetchLiteappApiSubmissionsFetchPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>): Mutation<FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostError, MutationVariables<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext> | MutationFiltersByMutationKey<FetchLiteappApiSubmissionsFetchPostSchema, FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostParameters, OperationError<FetchLiteappApiSubmissionsFetchPostError>, TContext>): Array<Mutation<FetchLiteappApiSubmissionsFetchPostData, FetchLiteappApiSubmissionsFetchPostError, MutationVariables<FetchLiteappApiSubmissionsFetchPostBody, FetchLiteappApiSubmissionsFetchPostParameters>, TContext>>;
        };
        schema: FetchLiteappApiSubmissionsFetchPostSchema;
        types: {
            parameters: FetchLiteappApiSubmissionsFetchPostParameters;
            data: FetchLiteappApiSubmissionsFetchPostData;
            error: FetchLiteappApiSubmissionsFetchPostError;
            body: FetchLiteappApiSubmissionsFetchPostBody;
        };
    };
    /** @summary Has Messages */
    hasMessagesLiteappApiMessagesHasMessagesPost: {
        /** @summary Has Messages */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters, TMeta, TSignal>, client?: (schema: HasMessagesLiteappApiMessagesHasMessagesPostSchema, options: ServiceOperationMutationFnOptions<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostError>>): Promise<RequestFnResponse<HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostError>>;
        /** @summary Has Messages */
        getMutationKey(parameters: DeepReadonly<HasMessagesLiteappApiMessagesHasMessagesPostParameters> | void): ServiceOperationMutationKey<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Has Messages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends HasMessagesLiteappApiMessagesHasMessagesPostBody, TContext = unknown>(parameters: DeepReadonly<HasMessagesLiteappApiMessagesHasMessagesPostParameters>, options?: ServiceOperationUseMutationOptions<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, TVariables, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>): UseMutationResult<HasMessagesLiteappApiMessagesHasMessagesPostData, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TVariables | void, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Has Messages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, TVariables, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>): UseMutationResult<HasMessagesLiteappApiMessagesHasMessagesPostData, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Has Messages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const hasMessagesLiteappApiMessagesHasMessagesPostTotal = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const hasMessagesLiteappApiMessagesHasMessagesPostTotal = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext> | MutationFiltersByMutationKey<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Has Messages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const hasMessagesLiteappApiMessagesHasMessagesPostPendingMutationVariables = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const hasMessagesLiteappApiMessagesHasMessagesPostMutationData = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<HasMessagesLiteappApiMessagesHasMessagesPostData, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, MutationVariables<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext> | MutationFiltersByMutationKey<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>;
            select?: (mutation: Mutation<HasMessagesLiteappApiMessagesHasMessagesPostData, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, MutationVariables<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Has Messages */
        isMutating<TContext>(filters?: MutationFiltersByParameters<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext> | MutationFiltersByMutationKey<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Has Messages
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.hasMessagesLiteappApiMessagesHasMessagesPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext> | MutationFiltersByMutationKey<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>): Mutation<HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostError, MutationVariables<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext> | MutationFiltersByMutationKey<HasMessagesLiteappApiMessagesHasMessagesPostSchema, HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostParameters, OperationError<HasMessagesLiteappApiMessagesHasMessagesPostError>, TContext>): Array<Mutation<HasMessagesLiteappApiMessagesHasMessagesPostData, HasMessagesLiteappApiMessagesHasMessagesPostError, MutationVariables<HasMessagesLiteappApiMessagesHasMessagesPostBody, HasMessagesLiteappApiMessagesHasMessagesPostParameters>, TContext>>;
        };
        schema: HasMessagesLiteappApiMessagesHasMessagesPostSchema;
        types: {
            parameters: HasMessagesLiteappApiMessagesHasMessagesPostParameters;
            data: HasMessagesLiteappApiMessagesHasMessagesPostData;
            error: HasMessagesLiteappApiMessagesHasMessagesPostError;
            body: HasMessagesLiteappApiMessagesHasMessagesPostBody;
        };
    };
    /** @summary Search Users */
    searchUsersLiteappApiUpdatesSearchUsersPost: {
        /** @summary Search Users */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, TMeta, TSignal>, client?: (schema: SearchUsersLiteappApiUpdatesSearchUsersPostSchema, options: ServiceOperationMutationFnOptions<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostError>>): Promise<RequestFnResponse<SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostError>>;
        /** @summary Search Users */
        getMutationKey(parameters: DeepReadonly<SearchUsersLiteappApiUpdatesSearchUsersPostParameters> | void): ServiceOperationMutationKey<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Search Users
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SearchUsersLiteappApiUpdatesSearchUsersPostBody, TContext = unknown>(parameters: DeepReadonly<SearchUsersLiteappApiUpdatesSearchUsersPostParameters>, options?: ServiceOperationUseMutationOptions<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, TVariables, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>): UseMutationResult<SearchUsersLiteappApiUpdatesSearchUsersPostData, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Search Users
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, TVariables, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>): UseMutationResult<SearchUsersLiteappApiUpdatesSearchUsersPostData, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Search Users
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const searchUsersLiteappApiUpdatesSearchUsersPostTotal = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const searchUsersLiteappApiUpdatesSearchUsersPostTotal = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext> | MutationFiltersByMutationKey<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Search Users
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const searchUsersLiteappApiUpdatesSearchUsersPostPendingMutationVariables = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const searchUsersLiteappApiUpdatesSearchUsersPostMutationData = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SearchUsersLiteappApiUpdatesSearchUsersPostData, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, MutationVariables<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext> | MutationFiltersByMutationKey<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>;
            select?: (mutation: Mutation<SearchUsersLiteappApiUpdatesSearchUsersPostData, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, MutationVariables<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Search Users */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext> | MutationFiltersByMutationKey<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Search Users
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.searchUsersLiteappApiUpdatesSearchUsersPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext> | MutationFiltersByMutationKey<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>): Mutation<SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostError, MutationVariables<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext> | MutationFiltersByMutationKey<SearchUsersLiteappApiUpdatesSearchUsersPostSchema, SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostParameters, OperationError<SearchUsersLiteappApiUpdatesSearchUsersPostError>, TContext>): Array<Mutation<SearchUsersLiteappApiUpdatesSearchUsersPostData, SearchUsersLiteappApiUpdatesSearchUsersPostError, MutationVariables<SearchUsersLiteappApiUpdatesSearchUsersPostBody, SearchUsersLiteappApiUpdatesSearchUsersPostParameters>, TContext>>;
        };
        schema: SearchUsersLiteappApiUpdatesSearchUsersPostSchema;
        types: {
            parameters: SearchUsersLiteappApiUpdatesSearchUsersPostParameters;
            data: SearchUsersLiteappApiUpdatesSearchUsersPostData;
            error: SearchUsersLiteappApiUpdatesSearchUsersPostError;
            body: SearchUsersLiteappApiUpdatesSearchUsersPostBody;
        };
    };
    /** @summary Search Data */
    searchDataLiteappApiUpdatesSearchDataPost: {
        /** @summary Search Data */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters, TMeta, TSignal>, client?: (schema: SearchDataLiteappApiUpdatesSearchDataPostSchema, options: ServiceOperationMutationFnOptions<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostError>>): Promise<RequestFnResponse<SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostError>>;
        /** @summary Search Data */
        getMutationKey(parameters: DeepReadonly<SearchDataLiteappApiUpdatesSearchDataPostParameters> | void): ServiceOperationMutationKey<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Search Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends SearchDataLiteappApiUpdatesSearchDataPostBody, TContext = unknown>(parameters: DeepReadonly<SearchDataLiteappApiUpdatesSearchDataPostParameters>, options?: ServiceOperationUseMutationOptions<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, TVariables, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>): UseMutationResult<SearchDataLiteappApiUpdatesSearchDataPostData, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Search Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, TVariables, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>): UseMutationResult<SearchDataLiteappApiUpdatesSearchDataPostData, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Search Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const searchDataLiteappApiUpdatesSearchDataPostTotal = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const searchDataLiteappApiUpdatesSearchDataPostTotal = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext> | MutationFiltersByMutationKey<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Search Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const searchDataLiteappApiUpdatesSearchDataPostPendingMutationVariables = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const searchDataLiteappApiUpdatesSearchDataPostMutationData = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<SearchDataLiteappApiUpdatesSearchDataPostData, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, MutationVariables<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext> | MutationFiltersByMutationKey<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>;
            select?: (mutation: Mutation<SearchDataLiteappApiUpdatesSearchDataPostData, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, MutationVariables<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Search Data */
        isMutating<TContext>(filters?: MutationFiltersByParameters<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext> | MutationFiltersByMutationKey<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Search Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.searchDataLiteappApiUpdatesSearchDataPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext> | MutationFiltersByMutationKey<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>): Mutation<SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostError, MutationVariables<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext> | MutationFiltersByMutationKey<SearchDataLiteappApiUpdatesSearchDataPostSchema, SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostParameters, OperationError<SearchDataLiteappApiUpdatesSearchDataPostError>, TContext>): Array<Mutation<SearchDataLiteappApiUpdatesSearchDataPostData, SearchDataLiteappApiUpdatesSearchDataPostError, MutationVariables<SearchDataLiteappApiUpdatesSearchDataPostBody, SearchDataLiteappApiUpdatesSearchDataPostParameters>, TContext>>;
        };
        schema: SearchDataLiteappApiUpdatesSearchDataPostSchema;
        types: {
            parameters: SearchDataLiteappApiUpdatesSearchDataPostParameters;
            data: SearchDataLiteappApiUpdatesSearchDataPostData;
            error: SearchDataLiteappApiUpdatesSearchDataPostError;
            body: SearchDataLiteappApiUpdatesSearchDataPostBody;
        };
    };
    /** @summary Download Data */
    downloadDataLiteappApiUpdatesDownloadDataPost: {
        /** @summary Download Data */
        <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(options: ServiceOperationMutationFnOptions<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, TMeta, TSignal>, client?: (schema: DownloadDataLiteappApiUpdatesDownloadDataPostSchema, options: ServiceOperationMutationFnOptions<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, TMeta, TSignal>) => Promise<RequestFnResponse<DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostError>>): Promise<RequestFnResponse<DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostError>>;
        /** @summary Download Data */
        getMutationKey(parameters: DeepReadonly<DownloadDataLiteappApiUpdatesDownloadDataPostParameters> | void): ServiceOperationMutationKey<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostParameters>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Download Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends DownloadDataLiteappApiUpdatesDownloadDataPostBody, TContext = unknown>(parameters: DeepReadonly<DownloadDataLiteappApiUpdatesDownloadDataPostParameters>, options?: ServiceOperationUseMutationOptions<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, TVariables, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>): UseMutationResult<DownloadDataLiteappApiUpdatesDownloadDataPostData, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TVariables, TContext>;
        /**
         * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
         * Handles loading state, optimistic updates, and error handling.
         *
         * @summary Download Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
         * @example Mutation with predefined parameters, e.g., for updating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useMutation({
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * })
         * mutate(body);
         * ```
         * @example Mutation without predefined parameters, e.g., for creating
         * ```ts
         * const { mutate, isPending } = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useMutation()
         * mutate({
         *     body: bodyPayload,
         *     header: {
         *         "x-wbs-auth-token": xWbsAuthToken
         *     }
         * });
         * ```
         */
        useMutation<TVariables extends MutationVariables<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters>, TContext = unknown>(parameters: void, options?: ServiceOperationUseMutationOptions<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, TVariables, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>): UseMutationResult<DownloadDataLiteappApiUpdatesDownloadDataPostData, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TVariables, TContext>;
        /**
         * Returns the count of currently in-progress mutations.
         *
         * @summary Download Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
         * @example Check how many mutations are currently in progress for the specified service method.
         * ```ts
         * const downloadDataLiteappApiUpdatesDownloadDataPostTotal = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useIsMutating()
         * ```
         * @example Check how many mutations are currently in progress with the specified parameters.
         * ```ts
         * const downloadDataLiteappApiUpdatesDownloadDataPostTotal = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useIsMutating({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * })
         * ```
         */
        useIsMutating<TContext = unknown>(filters?: MutationFiltersByParameters<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext> | MutationFiltersByMutationKey<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>): number;
        /**
         * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
         *
         * @summary Download Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
         * @example Get all variables of all running mutations.
         * ```ts
         * const downloadDataLiteappApiUpdatesDownloadDataPostPendingMutationVariables = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useMutationState({
         *     filters: {
         *         status: "pending"
         *     },
         *     select: mutation => mutation.state.variables
         * })
         * ```
         * @example Get all data for specific mutations via the `parameters`.
         * ```ts
         * const downloadDataLiteappApiUpdatesDownloadDataPostMutationData = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.useMutationState({
         *     filters: {
         *         parameters: {
         *             header: {
         *                 "x-wbs-auth-token": xWbsAuthToken
         *             }
         *         }
         *     },
         *     select: mutation => mutation.state.data
         * })
         * ```
         */
        useMutationState<TContext = unknown, TResult = MutationState<DownloadDataLiteappApiUpdatesDownloadDataPostData, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, MutationVariables<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters>, TContext>>(options?: {
            filters?: MutationFiltersByParameters<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext> | MutationFiltersByMutationKey<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>;
            select?: (mutation: Mutation<DownloadDataLiteappApiUpdatesDownloadDataPostData, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, MutationVariables<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters>, TContext>) => TResult;
        }): Array<TResult>;
        /** @summary Download Data */
        isMutating<TContext>(filters?: MutationFiltersByParameters<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext> | MutationFiltersByMutationKey<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>): number;
        /**
         * Returns a `MutationCache` object that provides access to mutation cache operations
         * for the specific endpoint.
         *
         * @summary Download Data
         * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
         *
         * @example Find a mutation with specific parameters
         * ```ts
         * const mutationCache = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.getMutationCache();
         * const mutation = mutationCache.find({
         *     parameters: {
         *         header: {
         *             "x-wbs-auth-token": xWbsAuthToken
         *         }
         *     }
         * });
         * ```
         *
         * @example Find all mutations for the endpoint
         * ```ts
         * const mutationCache = qraft.liteappApiService.downloadDataLiteappApiUpdatesDownloadDataPost.getMutationCache();
         * const mutations = mutationCache.findAll();
         * ```
         */
        getMutationCache(): Omit<MutationCache, "find" | "findAll"> & {
            find<TContext = unknown>(filters: MutationFiltersByParameters<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext> | MutationFiltersByMutationKey<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>): Mutation<DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostError, MutationVariables<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters>, TContext> | undefined;
            findAll<TContext = unknown>(filters?: MutationFiltersByParameters<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext> | MutationFiltersByMutationKey<DownloadDataLiteappApiUpdatesDownloadDataPostSchema, DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostParameters, OperationError<DownloadDataLiteappApiUpdatesDownloadDataPostError>, TContext>): Array<Mutation<DownloadDataLiteappApiUpdatesDownloadDataPostData, DownloadDataLiteappApiUpdatesDownloadDataPostError, MutationVariables<DownloadDataLiteappApiUpdatesDownloadDataPostBody, DownloadDataLiteappApiUpdatesDownloadDataPostParameters>, TContext>>;
        };
        schema: DownloadDataLiteappApiUpdatesDownloadDataPostSchema;
        types: {
            parameters: DownloadDataLiteappApiUpdatesDownloadDataPostParameters;
            data: DownloadDataLiteappApiUpdatesDownloadDataPostData;
            error: DownloadDataLiteappApiUpdatesDownloadDataPostError;
            body: DownloadDataLiteappApiUpdatesDownloadDataPostBody;
        };
    };
}
/**
 * @summary Admin Forced
 * @description Admin/dev impersonation login: return a target user's auth token + profile.
 *
 * The target is restricted to the student/study-helper groups. The token is
 * issued WITHOUT rotating an existing one (unlike login). The legacy passcode
 * gate guarded non-local envs only and the app never sends a passcode, so this
 * is treated as the dev/local-bypass path.
 */
export const adminForcedLiteappApiAuthAdminForcedPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/auth/admin_forced",
        mediaType: ["application/json"]
    }
} as {
    schema: AdminForcedLiteappApiAuthAdminForcedPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["adminForcedLiteappApiAuthAdminForcedPost"];
};
/**
 * @summary Forget Password
 * @description Request a password reset (pre-auth, device-verified only).
 *
 * The error wire-shape must carry a TOP-LEVEL ``success:false`` with the payload
 * under ``data``. The shared HTTP exception handler only emits ``{data: ...}``,
 * so this endpoint builds the envelope directly via ``JSONResponse``.
 */
export const forgetPasswordLiteappApiAuthForgetPasswordPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/auth/forget_password",
        mediaType: ["application/json"]
    }
} as {
    schema: ForgetPasswordLiteappApiAuthForgetPasswordPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["forgetPasswordLiteappApiAuthForgetPasswordPost"];
};
/**
 * @summary Login
 * @description Email/password login.
 *
 * Order: validate user_login/password -> verify password (wrong password is
 * ``incorrect_password`` at 422, NOT forbidden) -> eligibility gate
 * (``incorrect_profile_type`` / ``incorrect_langauge``, both 401) -> rotate the
 * device token.
 *
 * The error wire-shape carries a TOP-LEVEL ``success:false`` and the unknown-email
 * branch is a 433 ``validation_error`` (NOT a 404), so this builds the envelope
 * directly via ``JSONResponse`` rather than the shared ``{data: ...}`` handler.
 */
export const loginLiteappApiAuthLoginPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/auth/login",
        mediaType: ["application/json"]
    }
} as {
    schema: LoginLiteappApiAuthLoginPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["loginLiteappApiAuthLoginPost"];
};
/**
 * @summary Register User
 * @description Register a new student.
 *
 * The error wire-shape carries a TOP-LEVEL ``success:false``; a field failure is
 * a 433 ``validation_error`` with nested ``validations.<field>`` (duplicate email
 * -> ``email_already_used``; mismatch -> ``parameter_value_mismatch``), so this
 * builds the envelope directly via ``JSONResponse`` rather than the shared
 * ``{data: ...}`` handler.
 */
export const registerUserLiteappApiAuthRegisterPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/auth/register",
        mediaType: ["application/json"]
    }
} as {
    schema: RegisterUserLiteappApiAuthRegisterPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["registerUserLiteappApiAuthRegisterPost"];
};
/** @summary Logout */
export const logoutLiteappApiAuthLogoutPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/auth/logout"
    }
} as {
    schema: LogoutLiteappApiAuthLogoutPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["logoutLiteappApiAuthLogoutPost"];
};
/** @summary Info */
export const infoLiteappApiAppInfoPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/app/info"
    }
} as {
    schema: InfoLiteappApiAppInfoPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["infoLiteappApiAppInfoPost"];
};
/** @summary Register Device */
export const registerDeviceLiteappApiDevicesRegisterPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/devices/register",
        mediaType: ["application/json"]
    }
} as {
    schema: RegisterDeviceLiteappApiDevicesRegisterPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["registerDeviceLiteappApiDevicesRegisterPost"];
};
/** @summary Init */
export const initLiteappApiDownloadsInitPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/downloads/init"
    }
} as {
    schema: InitLiteappApiDownloadsInitPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["initLiteappApiDownloadsInitPost"];
};
/** @summary Types */
export const typesLiteappApiDownloadsTypesPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/downloads/types"
    }
} as {
    schema: TypesLiteappApiDownloadsTypesPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["typesLiteappApiDownloadsTypesPost"];
};
/** @summary Download Zip */
export const downloadZipLiteappApiDownloadsNameZipGet = {
    schema: {
        method: "get",
        url: "/liteapp-api/downloads/{name}.zip"
    }
} as {
    schema: DownloadZipLiteappApiDownloadsNameZipGetSchema;
    [QraftServiceOperationsToken]: LiteappApiService["downloadZipLiteappApiDownloadsNameZipGet"];
};
/** @summary Translations */
export const translationsLiteappApiLanguagesTranslationsPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/languages/translations"
    }
} as {
    schema: TranslationsLiteappApiLanguagesTranslationsPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["translationsLiteappApiLanguagesTranslationsPost"];
};
/** @summary Detail */
export const detailLiteappApiPagesDetailPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/pages/detail",
        mediaType: ["application/json"]
    }
} as {
    schema: DetailLiteappApiPagesDetailPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["detailLiteappApiPagesDetailPost"];
};
/** @summary Me */
export const meLiteappApiUsersMePost = {
    schema: {
        method: "post",
        url: "/liteapp-api/users/me"
    }
} as {
    schema: MeLiteappApiUsersMePostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["meLiteappApiUsersMePost"];
};
/** @summary Info */
export const infoLiteappApiUsersInfoPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/users/info",
        mediaType: ["application/json"]
    }
} as {
    schema: InfoLiteappApiUsersInfoPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["infoLiteappApiUsersInfoPost"];
};
/** @summary Submit */
export const submitLiteappApiOnboardingsSubmitPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/onboardings/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: SubmitLiteappApiOnboardingsSubmitPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["submitLiteappApiOnboardingsSubmitPost"];
};
/** @summary Topics Mark Complete */
export const topicsMarkCompleteLiteappApiTopicsMarkCompletePost = {
    schema: {
        method: "post",
        url: "/liteapp-api/topics/mark_complete",
        mediaType: ["application/json"]
    }
} as {
    schema: TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["topicsMarkCompleteLiteappApiTopicsMarkCompletePost"];
};
/** @summary Quizzes Submit */
export const quizzesSubmitLiteappApiQuizzesSubmitPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/quizzes/submit",
        mediaType: ["application/json"]
    }
} as {
    schema: QuizzesSubmitLiteappApiQuizzesSubmitPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["quizzesSubmitLiteappApiQuizzesSubmitPost"];
};
/** @summary Fetch */
export const fetchLiteappApiNotificationsFetchPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/notifications/fetch",
        mediaType: ["application/json"]
    }
} as {
    schema: FetchLiteappApiNotificationsFetchPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["fetchLiteappApiNotificationsFetchPost"];
};
/** @summary Fetch */
export const fetchLiteappApiSubmissionsFetchPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/submissions/fetch",
        mediaType: ["application/json"]
    }
} as {
    schema: FetchLiteappApiSubmissionsFetchPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["fetchLiteappApiSubmissionsFetchPost"];
};
/** @summary Has Messages */
export const hasMessagesLiteappApiMessagesHasMessagesPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/messages/has_messages"
    }
} as {
    schema: HasMessagesLiteappApiMessagesHasMessagesPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["hasMessagesLiteappApiMessagesHasMessagesPost"];
};
/** @summary Search Users */
export const searchUsersLiteappApiUpdatesSearchUsersPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/updates/search_users",
        mediaType: ["application/json"]
    }
} as {
    schema: SearchUsersLiteappApiUpdatesSearchUsersPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["searchUsersLiteappApiUpdatesSearchUsersPost"];
};
/** @summary Search Data */
export const searchDataLiteappApiUpdatesSearchDataPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/updates/search_data",
        mediaType: ["application/json"]
    }
} as {
    schema: SearchDataLiteappApiUpdatesSearchDataPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["searchDataLiteappApiUpdatesSearchDataPost"];
};
/** @summary Download Data */
export const downloadDataLiteappApiUpdatesDownloadDataPost = {
    schema: {
        method: "post",
        url: "/liteapp-api/updates/download_data",
        mediaType: ["application/json"]
    }
} as {
    schema: DownloadDataLiteappApiUpdatesDownloadDataPostSchema;
    [QraftServiceOperationsToken]: LiteappApiService["downloadDataLiteappApiUpdatesDownloadDataPost"];
};
export const liteappApiService = {
    adminForcedLiteappApiAuthAdminForcedPost,
    forgetPasswordLiteappApiAuthForgetPasswordPost,
    loginLiteappApiAuthLoginPost,
    registerUserLiteappApiAuthRegisterPost,
    logoutLiteappApiAuthLogoutPost,
    infoLiteappApiAppInfoPost,
    registerDeviceLiteappApiDevicesRegisterPost,
    initLiteappApiDownloadsInitPost,
    typesLiteappApiDownloadsTypesPost,
    downloadZipLiteappApiDownloadsNameZipGet,
    translationsLiteappApiLanguagesTranslationsPost,
    detailLiteappApiPagesDetailPost,
    meLiteappApiUsersMePost,
    infoLiteappApiUsersInfoPost,
    submitLiteappApiOnboardingsSubmitPost,
    topicsMarkCompleteLiteappApiTopicsMarkCompletePost,
    quizzesSubmitLiteappApiQuizzesSubmitPost,
    fetchLiteappApiNotificationsFetchPost,
    fetchLiteappApiSubmissionsFetchPost,
    hasMessagesLiteappApiMessagesHasMessagesPost,
    searchUsersLiteappApiUpdatesSearchUsersPost,
    searchDataLiteappApiUpdatesSearchDataPost,
    downloadDataLiteappApiUpdatesDownloadDataPost
} as const;
type AdminForcedLiteappApiAuthAdminForcedPostSchema = {
    method: "post";
    url: "/liteapp-api/auth/admin_forced";
    mediaType: [
        "application/json"
    ];
};
type AdminForcedLiteappApiAuthAdminForcedPostParameters = paths["/liteapp-api/auth/admin_forced"]["post"]["parameters"];
type AdminForcedLiteappApiAuthAdminForcedPostData = paths["/liteapp-api/auth/admin_forced"]["post"]["responses"]["200"]["content"]["application/json"];
type AdminForcedLiteappApiAuthAdminForcedPostError = paths["/liteapp-api/auth/admin_forced"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/auth/admin_forced"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/liteapp-api/auth/admin_forced"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/auth/admin_forced"]["post"]["responses"]["422"]["content"]["application/json"];
type AdminForcedLiteappApiAuthAdminForcedPostBody = paths["/liteapp-api/auth/admin_forced"]["post"]["requestBody"]["content"]["application/json"];
type ForgetPasswordLiteappApiAuthForgetPasswordPostSchema = {
    method: "post";
    url: "/liteapp-api/auth/forget_password";
    mediaType: [
        "application/json"
    ];
};
type ForgetPasswordLiteappApiAuthForgetPasswordPostParameters = paths["/liteapp-api/auth/forget_password"]["post"]["parameters"];
type ForgetPasswordLiteappApiAuthForgetPasswordPostData = paths["/liteapp-api/auth/forget_password"]["post"]["responses"]["200"]["content"]["application/json"];
type ForgetPasswordLiteappApiAuthForgetPasswordPostError = paths["/liteapp-api/auth/forget_password"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/auth/forget_password"]["post"]["responses"]["422"]["content"]["application/json"];
type ForgetPasswordLiteappApiAuthForgetPasswordPostBody = paths["/liteapp-api/auth/forget_password"]["post"]["requestBody"]["content"]["application/json"];
type LoginLiteappApiAuthLoginPostSchema = {
    method: "post";
    url: "/liteapp-api/auth/login";
    mediaType: [
        "application/json"
    ];
};
type LoginLiteappApiAuthLoginPostParameters = paths["/liteapp-api/auth/login"]["post"]["parameters"];
type LoginLiteappApiAuthLoginPostData = paths["/liteapp-api/auth/login"]["post"]["responses"]["200"]["content"]["application/json"];
type LoginLiteappApiAuthLoginPostError = paths["/liteapp-api/auth/login"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/auth/login"]["post"]["responses"]["422"]["content"]["application/json"];
type LoginLiteappApiAuthLoginPostBody = paths["/liteapp-api/auth/login"]["post"]["requestBody"]["content"]["application/json"];
type RegisterUserLiteappApiAuthRegisterPostSchema = {
    method: "post";
    url: "/liteapp-api/auth/register";
    mediaType: [
        "application/json"
    ];
};
type RegisterUserLiteappApiAuthRegisterPostParameters = paths["/liteapp-api/auth/register"]["post"]["parameters"];
type RegisterUserLiteappApiAuthRegisterPostData = paths["/liteapp-api/auth/register"]["post"]["responses"]["200"]["content"]["application/json"];
type RegisterUserLiteappApiAuthRegisterPostError = paths["/liteapp-api/auth/register"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/auth/register"]["post"]["responses"]["422"]["content"]["application/json"];
type RegisterUserLiteappApiAuthRegisterPostBody = paths["/liteapp-api/auth/register"]["post"]["requestBody"]["content"]["application/json"];
type LogoutLiteappApiAuthLogoutPostSchema = {
    method: "post";
    url: "/liteapp-api/auth/logout";
};
type LogoutLiteappApiAuthLogoutPostParameters = paths["/liteapp-api/auth/logout"]["post"]["parameters"];
type LogoutLiteappApiAuthLogoutPostData = paths["/liteapp-api/auth/logout"]["post"]["responses"]["200"]["content"]["application/json"];
type LogoutLiteappApiAuthLogoutPostError = paths["/liteapp-api/auth/logout"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/auth/logout"]["post"]["responses"]["422"]["content"]["application/json"];
type LogoutLiteappApiAuthLogoutPostBody = undefined;
type InfoLiteappApiAppInfoPostSchema = {
    method: "post";
    url: "/liteapp-api/app/info";
};
type InfoLiteappApiAppInfoPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type InfoLiteappApiAppInfoPostData = paths["/liteapp-api/app/info"]["post"]["responses"]["200"]["content"]["application/json"];
type InfoLiteappApiAppInfoPostError = unknown;
type InfoLiteappApiAppInfoPostBody = undefined;
type RegisterDeviceLiteappApiDevicesRegisterPostSchema = {
    method: "post";
    url: "/liteapp-api/devices/register";
    mediaType: [
        "application/json"
    ];
};
type RegisterDeviceLiteappApiDevicesRegisterPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type RegisterDeviceLiteappApiDevicesRegisterPostData = paths["/liteapp-api/devices/register"]["post"]["responses"]["200"]["content"]["application/json"];
type RegisterDeviceLiteappApiDevicesRegisterPostError = paths["/liteapp-api/devices/register"]["post"]["responses"]["422"]["content"]["application/json"];
type RegisterDeviceLiteappApiDevicesRegisterPostBody = paths["/liteapp-api/devices/register"]["post"]["requestBody"]["content"]["application/json"];
type InitLiteappApiDownloadsInitPostSchema = {
    method: "post";
    url: "/liteapp-api/downloads/init";
};
type InitLiteappApiDownloadsInitPostParameters = {
    query?: never;
    header?: never;
    path?: never;
};
type InitLiteappApiDownloadsInitPostData = paths["/liteapp-api/downloads/init"]["post"]["responses"]["200"]["content"]["application/json"];
type InitLiteappApiDownloadsInitPostError = unknown;
type InitLiteappApiDownloadsInitPostBody = undefined;
type TypesLiteappApiDownloadsTypesPostSchema = {
    method: "post";
    url: "/liteapp-api/downloads/types";
};
type TypesLiteappApiDownloadsTypesPostParameters = paths["/liteapp-api/downloads/types"]["post"]["parameters"];
type TypesLiteappApiDownloadsTypesPostData = paths["/liteapp-api/downloads/types"]["post"]["responses"]["200"]["content"]["application/json"];
type TypesLiteappApiDownloadsTypesPostError = paths["/liteapp-api/downloads/types"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/downloads/types"]["post"]["responses"]["422"]["content"]["application/json"];
type TypesLiteappApiDownloadsTypesPostBody = undefined;
type DownloadZipLiteappApiDownloadsNameZipGetSchema = {
    method: "get";
    url: "/liteapp-api/downloads/{name}.zip";
};
type DownloadZipLiteappApiDownloadsNameZipGetParameters = paths["/liteapp-api/downloads/{name}.zip"]["get"]["parameters"];
type DownloadZipLiteappApiDownloadsNameZipGetData = paths["/liteapp-api/downloads/{name}.zip"]["get"]["responses"]["200"]["content"]["application/json"];
type DownloadZipLiteappApiDownloadsNameZipGetError = paths["/liteapp-api/downloads/{name}.zip"]["get"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/downloads/{name}.zip"]["get"]["responses"]["422"]["content"]["application/json"];
type TranslationsLiteappApiLanguagesTranslationsPostSchema = {
    method: "post";
    url: "/liteapp-api/languages/translations";
};
type TranslationsLiteappApiLanguagesTranslationsPostParameters = paths["/liteapp-api/languages/translations"]["post"]["parameters"];
type TranslationsLiteappApiLanguagesTranslationsPostData = paths["/liteapp-api/languages/translations"]["post"]["responses"]["200"]["content"]["application/json"];
type TranslationsLiteappApiLanguagesTranslationsPostError = paths["/liteapp-api/languages/translations"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/languages/translations"]["post"]["responses"]["422"]["content"]["application/json"];
type TranslationsLiteappApiLanguagesTranslationsPostBody = undefined;
type DetailLiteappApiPagesDetailPostSchema = {
    method: "post";
    url: "/liteapp-api/pages/detail";
    mediaType: [
        "application/json"
    ];
};
type DetailLiteappApiPagesDetailPostParameters = paths["/liteapp-api/pages/detail"]["post"]["parameters"];
type DetailLiteappApiPagesDetailPostData = paths["/liteapp-api/pages/detail"]["post"]["responses"]["200"]["content"]["application/json"];
type DetailLiteappApiPagesDetailPostError = paths["/liteapp-api/pages/detail"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/pages/detail"]["post"]["responses"]["422"]["content"]["application/json"] | paths["/liteapp-api/pages/detail"]["post"]["responses"]["433"]["content"]["application/json"];
type DetailLiteappApiPagesDetailPostBody = paths["/liteapp-api/pages/detail"]["post"]["requestBody"]["content"]["application/json"];
type MeLiteappApiUsersMePostSchema = {
    method: "post";
    url: "/liteapp-api/users/me";
};
type MeLiteappApiUsersMePostParameters = paths["/liteapp-api/users/me"]["post"]["parameters"];
type MeLiteappApiUsersMePostData = paths["/liteapp-api/users/me"]["post"]["responses"]["200"]["content"]["application/json"];
type MeLiteappApiUsersMePostError = paths["/liteapp-api/users/me"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/users/me"]["post"]["responses"]["422"]["content"]["application/json"];
type MeLiteappApiUsersMePostBody = undefined;
type InfoLiteappApiUsersInfoPostSchema = {
    method: "post";
    url: "/liteapp-api/users/info";
    mediaType: [
        "application/json"
    ];
};
type InfoLiteappApiUsersInfoPostParameters = paths["/liteapp-api/users/info"]["post"]["parameters"];
type InfoLiteappApiUsersInfoPostData = paths["/liteapp-api/users/info"]["post"]["responses"]["200"]["content"]["application/json"];
type InfoLiteappApiUsersInfoPostError = paths["/liteapp-api/users/info"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/users/info"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/users/info"]["post"]["responses"]["422"]["content"]["application/json"];
type InfoLiteappApiUsersInfoPostBody = paths["/liteapp-api/users/info"]["post"]["requestBody"]["content"]["application/json"];
type SubmitLiteappApiOnboardingsSubmitPostSchema = {
    method: "post";
    url: "/liteapp-api/onboardings/submit";
    mediaType: [
        "application/json"
    ];
};
type SubmitLiteappApiOnboardingsSubmitPostParameters = paths["/liteapp-api/onboardings/submit"]["post"]["parameters"];
type SubmitLiteappApiOnboardingsSubmitPostData = paths["/liteapp-api/onboardings/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type SubmitLiteappApiOnboardingsSubmitPostError = paths["/liteapp-api/onboardings/submit"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/onboardings/submit"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/liteapp-api/onboardings/submit"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/onboardings/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type SubmitLiteappApiOnboardingsSubmitPostBody = paths["/liteapp-api/onboardings/submit"]["post"]["requestBody"]["content"]["application/json"];
type TopicsMarkCompleteLiteappApiTopicsMarkCompletePostSchema = {
    method: "post";
    url: "/liteapp-api/topics/mark_complete";
    mediaType: [
        "application/json"
    ];
};
type TopicsMarkCompleteLiteappApiTopicsMarkCompletePostParameters = paths["/liteapp-api/topics/mark_complete"]["post"]["parameters"];
type TopicsMarkCompleteLiteappApiTopicsMarkCompletePostData = paths["/liteapp-api/topics/mark_complete"]["post"]["responses"]["200"]["content"]["application/json"];
type TopicsMarkCompleteLiteappApiTopicsMarkCompletePostError = paths["/liteapp-api/topics/mark_complete"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/topics/mark_complete"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/liteapp-api/topics/mark_complete"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/topics/mark_complete"]["post"]["responses"]["422"]["content"]["application/json"];
type TopicsMarkCompleteLiteappApiTopicsMarkCompletePostBody = paths["/liteapp-api/topics/mark_complete"]["post"]["requestBody"]["content"]["application/json"];
type QuizzesSubmitLiteappApiQuizzesSubmitPostSchema = {
    method: "post";
    url: "/liteapp-api/quizzes/submit";
    mediaType: [
        "application/json"
    ];
};
type QuizzesSubmitLiteappApiQuizzesSubmitPostParameters = paths["/liteapp-api/quizzes/submit"]["post"]["parameters"];
type QuizzesSubmitLiteappApiQuizzesSubmitPostData = paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["200"]["content"]["application/json"];
type QuizzesSubmitLiteappApiQuizzesSubmitPostError = paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["400"]["content"]["application/json"] | paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["403"]["content"]["application/json"] | paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["404"]["content"]["application/json"] | paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["420"]["content"]["application/json"] | paths["/liteapp-api/quizzes/submit"]["post"]["responses"]["422"]["content"]["application/json"];
type QuizzesSubmitLiteappApiQuizzesSubmitPostBody = paths["/liteapp-api/quizzes/submit"]["post"]["requestBody"]["content"]["application/json"];
type FetchLiteappApiNotificationsFetchPostSchema = {
    method: "post";
    url: "/liteapp-api/notifications/fetch";
    mediaType: [
        "application/json"
    ];
};
type FetchLiteappApiNotificationsFetchPostParameters = paths["/liteapp-api/notifications/fetch"]["post"]["parameters"];
type FetchLiteappApiNotificationsFetchPostData = paths["/liteapp-api/notifications/fetch"]["post"]["responses"]["200"]["content"]["application/json"];
type FetchLiteappApiNotificationsFetchPostError = paths["/liteapp-api/notifications/fetch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/notifications/fetch"]["post"]["responses"]["422"]["content"]["application/json"];
type FetchLiteappApiNotificationsFetchPostBody = paths["/liteapp-api/notifications/fetch"]["post"]["requestBody"]["content"]["application/json"];
type FetchLiteappApiSubmissionsFetchPostSchema = {
    method: "post";
    url: "/liteapp-api/submissions/fetch";
    mediaType: [
        "application/json"
    ];
};
type FetchLiteappApiSubmissionsFetchPostParameters = paths["/liteapp-api/submissions/fetch"]["post"]["parameters"];
type FetchLiteappApiSubmissionsFetchPostData = paths["/liteapp-api/submissions/fetch"]["post"]["responses"]["200"]["content"]["application/json"];
type FetchLiteappApiSubmissionsFetchPostError = paths["/liteapp-api/submissions/fetch"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/submissions/fetch"]["post"]["responses"]["422"]["content"]["application/json"];
type FetchLiteappApiSubmissionsFetchPostBody = paths["/liteapp-api/submissions/fetch"]["post"]["requestBody"]["content"]["application/json"];
type HasMessagesLiteappApiMessagesHasMessagesPostSchema = {
    method: "post";
    url: "/liteapp-api/messages/has_messages";
};
type HasMessagesLiteappApiMessagesHasMessagesPostParameters = paths["/liteapp-api/messages/has_messages"]["post"]["parameters"];
type HasMessagesLiteappApiMessagesHasMessagesPostData = paths["/liteapp-api/messages/has_messages"]["post"]["responses"]["200"]["content"]["application/json"];
type HasMessagesLiteappApiMessagesHasMessagesPostError = paths["/liteapp-api/messages/has_messages"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/messages/has_messages"]["post"]["responses"]["422"]["content"]["application/json"];
type HasMessagesLiteappApiMessagesHasMessagesPostBody = undefined;
type SearchUsersLiteappApiUpdatesSearchUsersPostSchema = {
    method: "post";
    url: "/liteapp-api/updates/search_users";
    mediaType: [
        "application/json"
    ];
};
type SearchUsersLiteappApiUpdatesSearchUsersPostParameters = paths["/liteapp-api/updates/search_users"]["post"]["parameters"];
type SearchUsersLiteappApiUpdatesSearchUsersPostData = paths["/liteapp-api/updates/search_users"]["post"]["responses"]["200"]["content"]["application/json"];
type SearchUsersLiteappApiUpdatesSearchUsersPostError = paths["/liteapp-api/updates/search_users"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/updates/search_users"]["post"]["responses"]["422"]["content"]["application/json"];
type SearchUsersLiteappApiUpdatesSearchUsersPostBody = paths["/liteapp-api/updates/search_users"]["post"]["requestBody"]["content"]["application/json"];
type SearchDataLiteappApiUpdatesSearchDataPostSchema = {
    method: "post";
    url: "/liteapp-api/updates/search_data";
    mediaType: [
        "application/json"
    ];
};
type SearchDataLiteappApiUpdatesSearchDataPostParameters = paths["/liteapp-api/updates/search_data"]["post"]["parameters"];
type SearchDataLiteappApiUpdatesSearchDataPostData = paths["/liteapp-api/updates/search_data"]["post"]["responses"]["200"]["content"]["application/json"];
type SearchDataLiteappApiUpdatesSearchDataPostError = paths["/liteapp-api/updates/search_data"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/updates/search_data"]["post"]["responses"]["422"]["content"]["application/json"];
type SearchDataLiteappApiUpdatesSearchDataPostBody = paths["/liteapp-api/updates/search_data"]["post"]["requestBody"]["content"]["application/json"];
type DownloadDataLiteappApiUpdatesDownloadDataPostSchema = {
    method: "post";
    url: "/liteapp-api/updates/download_data";
    mediaType: [
        "application/json"
    ];
};
type DownloadDataLiteappApiUpdatesDownloadDataPostParameters = paths["/liteapp-api/updates/download_data"]["post"]["parameters"];
type DownloadDataLiteappApiUpdatesDownloadDataPostData = paths["/liteapp-api/updates/download_data"]["post"]["responses"]["200"]["content"]["application/json"];
type DownloadDataLiteappApiUpdatesDownloadDataPostError = paths["/liteapp-api/updates/download_data"]["post"]["responses"]["401"]["content"]["application/json"] | paths["/liteapp-api/updates/download_data"]["post"]["responses"]["422"]["content"]["application/json"];
type DownloadDataLiteappApiUpdatesDownloadDataPostBody = paths["/liteapp-api/updates/download_data"]["post"]["requestBody"]["content"]["application/json"];
